import moment from "moment";
import React, { MutableRefObject, useEffect, useLayoutEffect, useRef, useState } from "react";
import { Col, Row, Accordion, Card } from "react-bootstrap";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import CheckMarkFilled from "../../../assets/images/editIcons/checkMarkFilled.png";
import UrgentFilledSmall from "../../../assets/images/urgent_filled_small.svg";
import EditFilledSmall from "../../../assets/images/edit_small_filled_gray800.svg";
import UrgentOutlineLarge from "../../../assets/images/urgent_outline_large.svg";
import UrgentOutlineSmall from "../../../assets/images/urgent_outline_small.svg";
import CancelMarkFilled from "../../../assets/images/cancel_filled_small.svg";
import CheckOutlineLarge from "../../../assets/images/check_outline_large.svg";
import CancelOutlineLarge from "../../../assets/images/cancel_outline_large.svg";
import ForwardOutlineLarge from "../../../assets/images/forward_outline_large.svg";
import EditIcon from "../../../assets/images/editIcons/editSmallIcon.png";
import cancelImage from "../../../assets/images/tabImages/cancelButton.png";
import CancelPopup from "../../../common/alertPopup/cancelPopup";
import RejectModal from "../../../common/modal/rejectModal/RejectModal";
import checkMarkImage from "../../../assets/images/tabImages/Check Mark_ Large_ Outline_blue_1.png";
import NewTransactionNotesTable from "../../../common/table/NewTransactionNotes/NewTransactionNotes";
import NewTask from './NewTask';
import { FeatureFlagsType } from '../../../common/customTypes/FeatureFlagsType';
import NewTaskCollapsed from './NewTaskCollapsed';
import DeleteTaskPopUp from '../../../common/alertPopup/DeleteTaskPopUp';
import crossIcon from "../../../assets/images/x_cancel_icon.png";
import checkIcon from '../../../assets/images/check_green_icon.png';
import { LightTooltip, normalizePhone, getAIEntityCount } from '../../../common/utils/appUtils';
import { createTransaction, showReadOnlyTransactionRequest } from '../../landingPage/LandingPageDucks';
import CopyToClipboard from "../../../common/copyToClipboard/copyToClipboard";
import CheckboxField from '../../../common/formFields/CheckboxField';
import AddNewIssue from '../../../assets/images/tabImages/AddNewIssue.png';
import aiProcessingIcon from "../../../assets/images/AI_Processing_Icon.svg";
import {
  getMomentDate,
  isPastDate
} from "../../../common/utils/appUtils";
import {
  setNextTransactionIdActionCreator,
  setPreviousTransactionActionCreator,
  clearTransactionId,
  sendOutboundTemplateFieldsActionCreator
} from "../../landingPage/LandingPageDucks";
import "../DataEntryDetails.scss";
import {
  getPreviousTransactionActionCreator,
  getRejectionLetterActionCreator,
  nextTransactionIdActionCreator,
  patchPatientNoteActionCreators,
  patchRequestorNoteActionCreators,
  rejectionContactOverrideActionCreator,
  setNextTransactionNullActionCreator,
  updateTransactionNotes,
  updateUserTasksActionCreator,
  updateUserTaskCommentsActionCreator,
  createUserTaskCommentActionCreator,
  addNewTaskActionCreator,
  updateTaskActionCreator,
  deleteTransactionTaskActionCreator,
  postRejectionDetailsActionCreator,
  resetDataEntryState,
  getQAIssuesActionCreator,
  getQAPDIssuesActionCreator,
  resolveQATransactionIssueActionCreator,
  removeQATransactionIssueActionCreator,
  submitAIFeedbackActionCreator,
  getAssessmentResultsActionCreator,
  deleteAIFeedbackActionCreator,
  readBarCodeDDSRequest,
  disputeIssueActionCreator,
  upholdIssueActionCreator,
  submitAIFeedbackBulkActionCreator,
  undoAIFeedbackBulkActionCreator
} from "../DataEntryDetailsDucks";
import { BillingFormconstants, FormConstants, RejectModalConstants } from "./DataEntryFieldsConstants";
import AddNewRequestor from "../../../assets/images/tabImages/AddNewRequestor.png";
import { FormStateMap, reduxForm } from "redux-form";
import localValidations from "./validations/localValidations";
import submitValidations from "./validations/submitValidations";
import DisplayAuditItem from "../../../common/auditItem/auditItem";
import toast from "react-hot-toast";
import WaitAndHoldModal from "../../../common/modal/WaitAndHoldModal";
import 'font-awesome/css/font-awesome.min.css';
import {
  generatePickerOptionsNoDefault
} from '../../../common/utils/appUtils';
import { API_FETCHING, API_SUCCESS, DEFAULT_DROPDOWN_VALUE, ReduxApiStatus } from "../../../common/constants/ApiConstants";
import AddIssueForm from "./AddIssueForm";
import { getQAFeatureFlagsRequest } from "../../login/LoginPageDucks";
import AssessmentFeedbackPopUp from "../../../common/alertPopup/AssessmentFeedbackPopUp";
import BulkActionsBar from "../../../common/bulkActions/BulkActionsBar";
import BulkFeedbackModal from "../../../common/bulkActions/BulkFeedbackModal";
import TransactionIssue, {QaError} from "../../../models/transactionIssue";
import { SensitiveInfoRelease, SensitiveInfoType, TransactionDetails } from "../../../models/transaction";
import Rejection from "../../../models/rejection";
import { Requestor } from "../../../models/requestor";
import { BulkActionHistoryEntry } from "../../../models/bulkFeedback";

import {
  AssessmentResult,
  CORRECT_FEEDBACK,
  DetectedEntity,
  PATIENT,
  RELEASE,
  EntityTypeId,
  FeedbackType,
  ReviewEntity,
  EntityType,
} from "../../../models/assessment";
import TransactionDocument from "../../../models/document";
import { RootState } from "typesafe-actions";
import { DocTypes } from "../../../common/constants/DocTypes";
import AuditData from "../../../models/auditData";
import { select } from "redux-saga/effects";
import { recordsRequestedDisplayNames } from "./RecordsRequestedField";

interface IpropType {
  patientDetails?: any;
  transactionNotes?: any;
  requestorDetails?: Requestor;
  transactionDetails: TransactionDetails;
  requestorBillingDetails?: any,
  dataEntryFormState?: any;
  getRejectionLetter?: any;
  transactionId: string;
  getPreviousTransaction?: any;
  setNextTransactionIDNull?: any;
  /**
   * Facility from which the transaction was opened.
   * Could be the organization ID of the transaction, or the parent org.
   */
  facilityId?: number,
  /**
   * Organization ID of the open transaction.
   */
  organizationId?: number,
  getNextTransactionId?: (facilityId: number, context: number) => void,
  previousTransactionId?: any;
  nextTransactionId?: any;
  setPreviousTransaction?: any;
  setNextTransactionID?: any;
  globalUserID?: any;
  patchPatientNotesData?: any;
  patchRequestorNotesData?: any;
  rejectionContactOverride?: any;
  rejectLetterData?: any;
  rejectLetterDataState?: any;
  transactionNoteTypes?: any;
  updateTransactionNotes?: any;
  userGroups?: any,
  userTasks: any,
  userTaskComments: any,
  updateUserTasks?: Function,
  updateUserTaskComments?: Function,
  userAttributes?: any,
  createUserTaskComment?: Function,
  addNewTask?: Function,
  updateTask?: Function,
  deleteTransactionTask?: Function,
  postRejectionAction?: (rejection: Rejection) => void,
  rejectCompleted?: false,
  certificationRequired?: any,
  resetForm: Function,
  resetDataEntryState?: Function,
  clearTransactionId?: Function,
  auditTrail?: readonly AuditData[],
  intiaTxlSagaCallCount?: any,
  createTransaction?: Function,
  requestContext?: number,
  closeReadOnlyModal?: Function,
  getQAFeatureFlagsRequest?: Function,
  QAFeatureFlags?: FeatureFlagsType,
  selectedHoldReasons?: any,
  getTransactionAttributes?: Function,
  getUserGroups?: (organizationId: number) => void,
  assessmentResult?: AssessmentResult,
  authorizedEntities: {readonly [key in EntityTypeId]?: boolean},
  getAssessmentResults?: (transactionId: string) => void,
  loadUnwaitedTx?: Function,
  sendOutboundTemplateFields?: Function,
  trackingLink?: string,
  qaErrors: QaError[],
  qaIssues: TransactionIssue[],
  getQAPDIssues?: (transactionId: string) => void,
  fetchQAIssues?: (transactionId: string) => void,
  resolveQAIssue?: (transactionId: string, issueId: string) => void,
  removeQAIssue?: (transactionId: string, issueId: string) => void,
  disputeIssue?: (id: string, reason: string, transactionId: string) => void,
  upholdIssue?: (id: string, reason: string, transactionId: string) => void,
  setEscalation?: Function,
  documentsList: readonly TransactionDocument[],
  /**
   * Quick Entry mode (Spec #34098 / F1a) moved the Previous/New/Next Request
   * footer to QuickEntryActionFooter.tsx (mounted in the right pane, per
   * master-demo-v6.html's own .action-footer) - this pane's own footer must
   * not ALSO render in that mode, or the specialist gets two copies of the
   * same navigation (direct user report). Classic mode is unaffected -
   * DataEntryDetails.tsx only passes true when isQuickEntryEligible().
   */
  hideFooter?: boolean,
  addFeedback?: (entityId: string, feedbackType: string) => void,
  deleteFeedback?: (entityId: string) => void,
  submitAIFeedbackBulk?: (entityIds: string[], feedbackType: string) => void,
  undoAIFeedbackBulk?: (entityIds: string[]) => void,
  readBarCodeDDSRequest?: Function,
  setPageNumber?: Function,
  pageNumber?: number,
  currentFile?: string,
  setCurrentFileType?: Function,
  currentFileType?: string,
}

interface ReduxStateProps {
  globalUserID?: number,
  userAttributes?: any,
  requestorBillingDetails?: any,
  transactionNoteTypes?: any,
  rejectLetterData?: any,
  rejectLetterDataState?: any,
  organizationId: number,
  facilityId?: number,
  nextTransactionId?: any,
  previousTransactionId?: any,
  dataEntryFormState?: any,
  userGroups?: any,
  rejectCompleted: boolean,
  certificationRequired?: boolean,
  intiaTxlSagaCallCount?: number,
  requestContext?: number,
  QAFeatureFlags?: FeatureFlagsType,
  selectedHoldReasons?: any,
  trackingLink?: any,
  assessmentResult?: AssessmentResult,
  aiFeedback?: readonly FeedbackType[],
  entityTypes?: readonly EntityType[],
  submitAIFeedbackStatus?: ReduxApiStatus,
}

function getStyles(status) {
  switch (status) {
    case "Completed":
      return { background: "darkseagreen" };
    case "In-Progress":
      return { background: "cadetblue" };
    case "Assigned":
      return { background: "#f2c6b3" };
    default:
      return { background: "#f2c6b3" };
  }
}

export function getDaysDiff(date: string) {
  if (date) {
    const now = moment();
    const numberOfDays = now.diff(date, "days");
    if (numberOfDays > 0) {
      return numberOfDays + " days ago";
    } else if (numberOfDays === 0) {
      return "Today";
    } else {
      return "In " + -numberOfDays + " days";
    }
  }
  return "";
}

export function TaskStatusDropdown(props) {
  return (
    <ul
      className="nav navbar-nav navbar-right"
      style={props.style || { height: "2rem" }}
    >
      <li className="dropdown">
        <span
          className="dropdown-toggle dropdown-style"
          style={getStyles(props.selectedStatus)}
          data-toggle="dropdown"
          role="button"
          aria-haspopup="true"
          aria-expanded="false"
        >
          {props.selectedStatus}
          <span className="caret"></span>
        </span>
        <ul className="dropdown-menu">
          <li
            className="list-item"
            onClick={() => props.onChange(props.id, "Completed")}
          >
            <span className="dot"></span> Completed{" "}
          </li>
          <li
            className="list-item"
            onClick={() => props.onChange(props.id, "In-Progress")}
          >
            <span className="dot inProgress"></span> In-Progress{" "}
          </li>
          <li
            className="list-item"
            onClick={() => props.onChange(props.id, "Assigned")}
          >
            <span className="dot assigned"></span> Assigned{" "}
          </li>
        </ul>
      </li>
    </ul>
  );
}

function DataEntryDetailsLeftPane(props: IpropType & ReduxStateProps) {
  const {
    patientDetails,
    transactionNotes,
    requestorDetails,
    transactionDetails,
    dataEntryFormState,
    assessmentResult,
    qaIssues,
    previousTransactionId,
    nextTransactionId,
    setPreviousTransaction,
    setNextTransactionID,
    documentsList,
    entityTypes,
  } = props;

  const defaultRequestorNotes = requestorDetails?.notes;
  const defaultPatientNotes = patientDetails?.notes;

  /**
   * TODO: Re-enable Multi State display when multi-state invoicing feature is ready
   *   Requires: ROIS_InvoiceItems_ins_sel stored procedure to return State column
   *   Related: MultiState feature flag in backend
   */
  // const documentStates = documentsList?.map(x => x?.state).filter((val, index, a) => val && a.indexOf(val) == index) ?? [];
  const documentStates = []; // hardcode as empty to hide multistate section
  
  const qaDocDesc = documentsList.find(doc => doc.type.role == DocTypes.QA)?.description;
  const reviewEntities = assessmentResult?.reviewEntities ?? [];

  const [showForm, setShowForm] = useState(false);
  const [show, setShow] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [showGrid, setShowGrid] = useState(false);
  const [editingTaskId, setEditingTaskId] = useState(0);
  const [rejectNotificationType, setRejectNotificationType] = useState("");
  const [showWaitModal, setShowWaitModal] = useState(false);
  const { values, initial } = dataEntryFormState || {};
  const [showDeleteTaskPopUp, setDeleteTaskPopUp] = useState(false);
  const [taskToDelete, setTaskToDelete] = useState('');
  const [patientNotes, setPatientNotes] = useState(patientDetails?.notes);
  const [patientNotesDialog, setPatientNotesDialog] = useState(patientDetails?.notes);
  const [showPatientNotesDialog, setShowPatientNotesDialog] = useState(false);
  const [requestorNotes, setRequestorNotes] = useState(requestorDetails?.notes);
  const [requestorNotesDialog, setRequestorNotesDialog] = useState(requestorDetails?.notes);
  const [showRequestorNotesDialog, setShowRequestorNotesDialog] = useState(false);
  const [SelectedTabView, setSelectedTabView] = useState("Summary");
  const [createTaskStatus, updateCreateTaskStatus] = useState(false);
  const inputPatientNotes = useRef() as MutableRefObject<HTMLTextAreaElement>;
  const inputRequestorNotes = useRef() as MutableRefObject<HTMLTextAreaElement>;
  const [showRejectCompletePopUp, setRejectCompletePopUp] = useState(false);
  const [transactionHoldReasonText, setTransactionHoldReasonText] = useState<any>("");
  const [requestTypeText, setRequestTypeText] = useState("");
  const [showAllIssues, setShowAllIssues] = useState(transactionDetails.isReadOnly);
  const [showAddFeedback, setShowAddFeedback] = useState(false);
  const [showAuthorizedEntities, setShowAuthorizedEntities] = useState(false);
  const [entityId, setEntityId] = useState("");
  const [entityType, setEntityType] = useState<EntityTypeId>();
  const [editIssue, setEditIssue] = useState<TransactionIssue | undefined>(undefined);
  const [disputingIssueId, setDisputingIssueId] = useState<string>("");
  const [submittingEntityIds, setSubmittingEntityIds] = useState<Set<string>>(new Set());

  // Bulk selection state
  const [selectedEntityIds, setSelectedEntityIds] = useState<Set<string>>(new Set());
  const [bulkActionHistory, setBulkActionHistory] = useState<BulkActionHistoryEntry[]>([]);
  const [showBulkRejectModal, setShowBulkRejectModal] = useState(false);
  const [isBulkSubmitting, setIsBulkSubmitting] = useState(false);

  // getQAFeatureFlagsRequest mount fetch moved to DataEntryDetails.tsx's
  // centralized initialAPICalls (AC16, Spec #34098 / F1a tidy-first #4) -
  // dispatched exactly once per transaction load instead of independently here.

  useEffect(() => {
    if (props.rejectLetterDataState === API_SUCCESS) {
      setShow(true);
    }
  }, [props.rejectLetterDataState]);

    useEffect(() => {
    setSubmittingEntityIds(prev => {
      if (prev.size === 0) return prev;
      const allEntities: DetectedEntity[] = [
        ...(assessmentResult?.detectedEntities ?? []),
        ...Object.values(assessmentResult?.patientNames ?? {}).flat(),
        ...Object.values(assessmentResult?.patientNameMissingPages ?? {}).flat(),
      ];
      const next = new Set<string>();
      prev.forEach(id => {
        const entity = allEntities.find(e => e.id === id);
        if (!entity?.feedback) next.add(id);
      });
      return next;
    });
  }, [assessmentResult]);

  const prevSubmitStatusRef = useRef(props.submitAIFeedbackStatus);
  useEffect(() => {
    if (prevSubmitStatusRef.current === API_FETCHING &&
        props.submitAIFeedbackStatus !== API_FETCHING) {
      props.getAssessmentResults?.(props.transactionId);
    }
    prevSubmitStatusRef.current = props.submitAIFeedbackStatus;
  }, [props.submitAIFeedbackStatus]);

  useEffect(() => {
    if (previousTransactionId?.id) {
      setPreviousTransaction(previousTransactionId.id);
    }
  }, [previousTransactionId, setPreviousTransaction]);

  useEffect(() => {
    if (nextTransactionId) {
      setNextTransactionID(nextTransactionId);
    }
  }, [nextTransactionId, setNextTransactionID]);

  useEffect(() => {
    if (showPatientNotesDialog && inputPatientNotes.current) {
      inputPatientNotes.current.focus();
    }
    if (showRequestorNotesDialog && inputRequestorNotes.current) {
      inputRequestorNotes.current.focus();
    }
  }, [showPatientNotesDialog, showRequestorNotesDialog]);

  useEffect(() => {
    if (props.rejectCompleted) {
      setRejectCompletePopUp(false);
    }
  }, [props.rejectCompleted]);

  useEffect(() => {
    if (requestorNotes !== defaultRequestorNotes) {
      setRequestorNotes(defaultRequestorNotes);
      setRequestorNotesDialog(requestorDetails?.notes);
    }
    if (patientNotes !== defaultPatientNotes) {
      setPatientNotes(defaultPatientNotes);
      setPatientNotesDialog(defaultPatientNotes);
    }
  }, [defaultRequestorNotes, defaultPatientNotes]);

  useEffect(() => {
    setTransactionHoldReasonText(transactionDetails?.transactionHoldReason);
  }, [transactionDetails?.transactionHoldReason]);

  useEffect(() => {
    if (transactionDetails?.requestPurpose?.typeName && transactionDetails?.requestPurpose?.name) {
      setRequestTypeText(`${transactionDetails.requestPurpose.typeName} | ${transactionDetails.requestPurpose.name}`);
    }
  }, [transactionDetails?.requestPurpose]);

  useEffect(() => {
    if (props.userGroups.length === 0 && props.organizationId != null) {
      props.getUserGroups?.(props.organizationId);
    }
  }, [props.userGroups, props.organizationId]);

  useEffect(() => {
    if (nextTransactionId) {
      setNextTransactionID(nextTransactionId);
    }
  }, [nextTransactionId, setNextTransactionID]);

  useEffect(() => {
    if (showPatientNotesDialog) {
      inputPatientNotes.current.focus();
    }
    if (showRequestorNotesDialog) {
      inputRequestorNotes.current.focus();
    }
  });
  useEffect(() => {
    if (props.rejectCompleted) {
      setRejectCompletePopUp(false);
    }
  });

  useEffect(() => {
    if (props.currentFileType) {
      if (props.currentFileType != DocTypes.RELEASE && props.currentFileType != DocTypes.QA) {
        setShowForm(false);
      }
    }
  }, [props.currentFileType]);

  useEffect(() => cancelIssueEdit(), [qaIssues]);

  const allSensitiveInfoValues = [FormConstants.GENETIC_INFORMATION, FormConstants.HIV, FormConstants.MENTAL_HEALTH, FormConstants.SUBSTANCE_ABUSE, FormConstants.STD]

  const informationToReleaseFromValues = transactionDetails.releaseInfo.find(info => info.dateOfService)?.dateOfService?.from;
  const informationToReleaseToValues = transactionDetails.releaseInfo.find(info => info.dateOfService)?.dateOfService?.to;
  const allDates = transactionDetails.releaseInfo.some(info => info.allDates);

  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });

  /**
   * Closes any open forms for adding, editing, disputing, or upholding issues.
   */
  const cancelIssueEdit = () => {
    setShowForm(false);
    setEditIssue(undefined);
    setDisputingIssueId("");
  }

  const resetTransaction = () => {
    if (props.resetDataEntryState) {
      props.resetDataEntryState();

    }
    if (props.clearTransactionId) {
      props.clearTransactionId();

    }
  }

  const showModel = () => {
    props.getRejectionLetter(props.transactionId);
  };

  const closeModel = () => {
    setShow(false);
  };
  const showCancel = () => {
    setShowCancelModal(true);
  };
  const closeCancel = () => {
    setShowCancelModal(false);
  };

  const goToPreviousTransaction = () => {
    resetTransaction();
    props.resetForm();
    props.getPreviousTransaction(props.transactionId);
    props.setNextTransactionIDNull();
  };

  const goToNextTransaction = () => {
    props.getNextTransactionId && props.facilityId && props.getNextTransactionId(props.facilityId, props.requestContext ?? 1);
    resetTransaction();
    props.resetForm();
  };

  const createNewTransaction = () => {
    props.createTransaction && props.createTransaction({ facilityId: props.organizationId})
    resetTransaction();
    props.resetForm();
  };
  const deleteTaskbyId = (id) => {
    setTaskToDelete(id);
  }

  const getConfirmation = (value) => {
    if (value === 'OK') {
      props.deleteTransactionTask && props.deleteTransactionTask(props.transactionId, taskToDelete)
      setTaskToDelete('')
    }
    if (value === 'Cancel') {
      setTaskToDelete('')
    }
  }

  const initiateCreateNewTask = () => {
    updateCreateTaskStatus(true)
    setEditingTaskId(0)
  };

  const patientNotesEditHandler = () => {
    setShowPatientNotesDialog(!showPatientNotesDialog);
    setPatientNotesDialog(patientNotes)
  };

  const patientNotesHandleChange = (event) => {
    setPatientNotesDialog(event.target.value);
  };

  const requestorNotesEditHandler = () => {
    setShowRequestorNotesDialog(!showRequestorNotesDialog);
    setRequestorNotesDialog(requestorNotes)
  };

  const requestorNotesHandleChange = (event) => {
    setRequestorNotesDialog(event.target.value);
  };
  const textDialogOnBlurPatient = () => {
    props.patchPatientNotesData(
      props.transactionDetails?.patient?.id,
      patientNotesDialog,
      props.globalUserID,
      props.transactionId
    );
    setTimeout(() => {
      setShowPatientNotesDialog(false);
    }, 200);
    setPatientNotes(patientNotesDialog);
  };
  const textDialogOnBlurRequestor = () => {
    props.patchRequestorNotesData(
      props.requestorDetails?.requestorID,
      requestorNotesDialog,
      props.globalUserID,
      props.requestorDetails?.requestorInfo?.id
    );
    setTimeout(() => {
      setShowRequestorNotesDialog(false);
    }, 200);
    setRequestorNotes(requestorNotesDialog);
  };

  const goToHealthOrganization = (data: any, radioSelect: string, templateId: string = DEFAULT_DROPDOWN_VALUE, templateFields = null) => {
    if(templateId === DEFAULT_DROPDOWN_VALUE){
      const requestPostObject: Rejection = {
        transactionId: props.transactionId,
        action: "",
        descriptionText: "",
        includeAuthForm: false,
        overrideEmail: "",
        overrideFax: "",
        cancelReasonIds: "",
        facilityId: props.facilityId ?? 0,
        requestContext: props.requestContext ?? 1,
      };
      if (radioSelect === "Email") {
        requestPostObject.action = 'email';
        requestPostObject.overrideEmail =
          data && data[RejectModalConstants.REJECT_MODAL_EMAIL];
        setRejectNotificationType("Email has been sent.");
      }
      else if (radioSelect === "Fax Number") {
        requestPostObject.action = 'fax';
        requestPostObject.overrideFax = data && data[RejectModalConstants.PHONE_FAX_NUMBER];
        setRejectNotificationType("Fax has been sent.");
      }
      else {
        requestPostObject.action = 'print';
        setRejectNotificationType("Notification has been sent to fulfillment for printing.");
      }
      requestPostObject.cancelReasonIds = data && data[RejectModalConstants.REJECT_REASON_IDS];
      requestPostObject.includeAuthForm = data && data[RejectModalConstants.REJECT_INCLUDE_AUTH_FORM] ? true : false;
      requestPostObject.descriptionText = data && data[RejectModalConstants.REJECT_MODAL_DESCRIPTION];

      props.postRejectionAction?.(requestPostObject);
    }
    else{
      let action = '';
      let contact = '';
      if (radioSelect === "Email") {
        action = 'email';
        contact = data && data[RejectModalConstants.REJECT_MODAL_EMAIL];
        setRejectNotificationType("Email has been sent.");
      }
      else if (radioSelect === "Fax Number") {
        action = 'fax';
        contact = data && data[RejectModalConstants.PHONE_FAX_NUMBER];
        setRejectNotificationType("Fax has been sent.");
      }
      else {
        action = 'print';
        setRejectNotificationType("Notification has been sent to fulfillment for printing.");
      }


      props.sendOutboundTemplateFields && props.sendOutboundTemplateFields(templateId, props.transactionId, action, templateFields, props.requestContext, contact)
    }

    setRejectCompletePopUp(true);
  };

  const renderSensitiveInfoItem = (item: string) => {
    const icon = transactionDetails.sensitiveInfo.find(info => info.name == item)?.stateID == SensitiveInfoRelease.Authorized ? checkMarkImage : crossIcon;
    return <>
      <span className="check-icon">
        <img src={icon} alt="" />
      </span>
      <span>{item}</span>
    </>;
  }

  const sendToBillToSame = () => {
    if(values){
    return values[BillingFormconstants.BILL_TO_REQUESTOR_NAME] === requestorDetails?.fullName &&
      values[BillingFormconstants.BILL_TO_FIRST_NAME] === requestorDetails?.requestorInfo?.firstName &&
      values[BillingFormconstants.BILL_TO_LAST_NAME] === requestorDetails?.requestorInfo?.lastName &&
      values[BillingFormconstants.BILL_TO_ADDRESS_LINE1] === requestorDetails?.requestorAddress?.address1 &&
      values[BillingFormconstants.BILL_TO_ADDRESS_LINE2] === requestorDetails?.requestorAddress?.address2 &&
      values[BillingFormconstants.BILL_TO_CITY] === requestorDetails?.requestorAddress?.city &&
      values[BillingFormconstants.BILL_TO_STATE] === requestorDetails?.requestorAddress?.state &&
      values[BillingFormconstants.BILL_TO_ZIP] === requestorDetails?.requestorAddress?.zipCode &&
      values[BillingFormconstants.BILL_TO_PHONE]?.replace(/[^0-9]/g, "") === requestorDetails?.requestorInfo?.phone?.replace(/[^0-9]/g, "") &&
      values[BillingFormconstants.BILL_TO_EMAIL_ADDRESS] ===  requestorDetails?.requestorInfo?.email
    }
    else
    return {}
  }

  const handlePageClick = (pageNumber: number, fileDesc?: string) => {
    if (pageNumber && fileDesc) {
      props.setPageNumber?.(pageNumber, fileDesc);
    }
  };

  const toastPop = (message) =>{
    toast(message, {id: "rejectPopUp", duration: 5000});
    setTimeout(() => {
      setRejectCompletePopUp(false);
      setRejectNotificationType("");
    }, 5000);
  }

  const showWaitModalPopup = () => {
    setShowWaitModal(true);
  };
  const closeWaitModal = () => {
    setShowWaitModal(false);
  };

  const getTransactionAttributes = (value) => {
    props.getTransactionAttributes && props.getTransactionAttributes(value);
  }

  const onChangeEscalation = (e) => {
    props.setEscalation && props.setEscalation(e.target.checked);
  }

  const onShowAllIssues = (ev: React.ChangeEvent<HTMLInputElement>) => {
    cancelIssueEdit();
    setShowAllIssues(ev.target.checked);
  }

  const onIssueResolved = (issueId: string) => {
    if (issueId == editIssue?.issueID || issueId == disputingIssueId) {
      cancelIssueEdit();
    }
    props.resolveQAIssue?.(props.transactionId, issueId);
    props.fetchQAIssues && props.fetchQAIssues(props.transactionId);
    props.getQAPDIssues && props.getQAPDIssues(props.transactionId);
  }

  const onIssueRemoved = (issueId: string) => {
    if (issueId == editIssue?.issueID || issueId == disputingIssueId) {
      cancelIssueEdit();
    }
    props.removeQAIssue?.(props.transactionId, issueId);
    props.fetchQAIssues && props.fetchQAIssues(props.transactionId);
    props.getQAPDIssues && props.getQAPDIssues(props.transactionId);
  }

  const shouldShowEntity = (entity: DetectedEntity | ReviewEntity) => {
    return showAuthorizedEntities || !props.authorizedEntities[entity.type];
  }

  const onIncorrectFeedbackClicked = (entity: DetectedEntity) => {
    setEntityId(entity.id);
    setEntityType(entity.type);
    setShowAddFeedback(true);
  }

  const addFeedback = (entityId: string, feedbackType: string) => {
    if (props.addFeedback) {
      setSubmittingEntityIds(prev => new Set(prev).add(entityId));
      props.addFeedback(entityId, feedbackType);
      props.getAssessmentResults && props.getAssessmentResults(props.transactionId);
      setSelectedEntityIds( prev => {
        if(prev.has(entityId)) {
          const newSet = new Set(prev);
          newSet.delete(entityId);
          return newSet;
        }
        return prev;
      })
    }
  }

  const undoFeedback = (entityId: string) => {
    if (props.deleteFeedback) {
      props.deleteFeedback(entityId);
      props.getAssessmentResults && props.getAssessmentResults(props.transactionId);
    }
  }

  // Bulk selection handlers
  const toggleEntitySelection = (entityId: string) => {
    setSelectedEntityIds(prev => {
      const newSet = new Set(prev);
      if (newSet.has(entityId)) {
        newSet.delete(entityId);
      } else {
        newSet.add(entityId);
      }
      return newSet;
    });
  };

  const toggleSelectAll = (entities: Array<{ id: string }>) => {
    const allIds = entities.map(ent => ent.id);
    if (allIds.every(id => selectedEntityIds.has(id))) {
      // Deselect all
      setSelectedEntityIds(prev => {
        const newSet = new Set(prev);
        allIds.forEach(id => newSet.delete(id));
        return newSet;
      });
    } else {
      // Select all
      setSelectedEntityIds(prev => {
        const newSet = new Set(prev);
        allIds.forEach(id => newSet.add(id));
        return newSet;
      });
    }
  };

  const clearSelection = () => {
    setSelectedEntityIds(new Set());
  };

  const handleBulkConfirm = () => {
    if (selectedEntityIds.size === 0) return;
    
    const entityIds = Array.from(selectedEntityIds as Set<string>);

    // Save current state for undo
    const historyEntry: BulkActionHistoryEntry = {
      timestamp: new Date(),
      actionType: 'confirm',
      affectedEntities: entityIds.map(entityId => ({
        entityId,
        previousFeedback: undefined,
        newFeedback: CORRECT_FEEDBACK
      })),
      description: `Confirmed ${selectedEntityIds.size} finding${selectedEntityIds.size !== 1 ? 's' : ''}`
    };
    
   props.submitAIFeedbackBulk && props.submitAIFeedbackBulk(entityIds, CORRECT_FEEDBACK);
    
    setBulkActionHistory(prev => [...prev, historyEntry]);
    clearSelection();
    toast.success(`Confirmed ${selectedEntityIds.size} finding${selectedEntityIds.size !== 1 ? 's' : ''}`);
    props.getAssessmentResults && props.getAssessmentResults(props.transactionId);
  };

  const handleBulkReject = () => {
    if (selectedEntityIds.size === 0) return;
    setShowBulkRejectModal(true);
  };

  const handleBulkRejectSubmit = (feedbackType: string) => {
    setIsBulkSubmitting(true);

    const entityIds = Array.from(selectedEntityIds as Set<string>);
    
    // Save history for undo
    const historyEntry: BulkActionHistoryEntry = {
      timestamp: new Date(),
      actionType: 'reject',
      affectedEntities: entityIds.map((entityId) => ({
        entityId,
        previousFeedback: undefined,
        newFeedback: feedbackType
      })),
      description: `Rejected ${selectedEntityIds.size} finding${selectedEntityIds.size !== 1 ? 's' : ''}`
    };
    
    props.submitAIFeedbackBulk && props.submitAIFeedbackBulk(entityIds, feedbackType);
    
    setBulkActionHistory(prev => [...prev, historyEntry]);
    setShowBulkRejectModal(false);
    setIsBulkSubmitting(false);
    clearSelection();
    toast.success(`Rejected ${selectedEntityIds.size} finding${selectedEntityIds.size !== 1 ? 's' : ''}`);
    props.getAssessmentResults && props.getAssessmentResults(props.transactionId);
  };

  const handleUndo = () => {
    if(bulkActionHistory.length > 0) {
      const lastAction = bulkActionHistory[bulkActionHistory.length - 1]
      const entityIds = lastAction.affectedEntities.map(({entityId}) => entityId);
      props.undoAIFeedbackBulk && props.undoAIFeedbackBulk(entityIds);
      setBulkActionHistory(prev => prev.slice(0, -1));
      toast.success('Undo Complete');
      props.getAssessmentResults && props.getAssessmentResults(props.transactionId);
      return;
    }

    const selectedWithFeedback = Array.from(selectedEntityIds as Set<string>).filter(id  => {
      const entity = props.assessmentResult?.detectedEntities.find(e => e.id === id);
      return entity?.feedback !== undefined;
    });

    if(selectedWithFeedback.length > 0){
      props.undoAIFeedbackBulk && props.undoAIFeedbackBulk(selectedWithFeedback); 
      clearSelection();
      toast.success(`Undo complete for ${selectedWithFeedback.length} findings${selectedWithFeedback.length !== 1 ? 's' : ''}`);
      props.getAssessmentResults && props.getAssessmentResults(props.transactionId);
    }
  };

  const showIssueEditForm = (issue: TransactionIssue | undefined = undefined) => {
      setEditIssue(issue);
      setShowForm(true);
      setDisputingIssueId("");
  }

  const showIssueAddForm = (issue: TransactionIssue | undefined = undefined) => {
    if (props.currentFileType == DocTypes.RELEASE || props.currentFileType == DocTypes.QA) {
      setEditIssue(issue);
      setShowForm(true);
      setDisputingIssueId("");
    } else {
      setShowForm(false);
    }
  }

  const setDisputeForm = (issueId: string) => {
    setEditIssue(undefined);
    setShowForm(false);
    setDisputingIssueId(issueId);
  }

  const onSubmitDispute = (issue: TransactionIssue) => {
    const reason = (document.getElementById("dispute-" + issue.issueID) as HTMLTextAreaElement)?.value;
    if (reason) {
      if (issue.disputed) {
        props.upholdIssue!(issue.issueID, reason, props.transactionId);
      } else {
        props.disputeIssue!(issue.issueID, reason, props.transactionId);
      }
    }
  }

  return (
    <div className="request-wrapper">
      <div className="content-body">
        <div className="request-id">
          <div>{props.transactionId}</div>
          <CopyToClipboard copyText={props.transactionId}/>
          <div className={"tx-status"}>{transactionDetails.transactionStatus.name}</div>
        </div>
        <Row>
          <Col className="bottom-border"/>
        </Row>

        <Row>
          <>

            <Col className="px-6  text-left col-6 cancel">
              {!transactionDetails?.isReadOnly && (
                  <>
              <span className="cancel" onClick={showCancel}>
                <img
                    className="cancelButton image-margin-cancel"
                    src={cancelImage}
                    alt="X"
                />
                Cancel
              </span>
                  </>
              )}
            </Col>
            {showCancelModal ? (
                <CancelPopup
                    show={showCancel}
                    handleClose={closeCancel}
                    headerText="Cancel request"
                    buttonText="Ok"
                    setShowCancelModal={setShowCancelModal}
                    resetForm={props.resetForm}
                    resetFormDataEntryState={resetTransaction}
                />
            ) : null}
            <Col
                className="px-6 text-right col-6 reject"
                style={{right: "0px"}}
            >
              {
                props.requestorDetails?.requestorID && ![250, 260, 300, 355].includes(transactionDetails.transactionStatus.id) ?
                    <span className="cancel" onClick={showModel}>
                  <i className="fa fa-envelope">&nbsp;</i>Outbound Communications
              </span> :
                    null}
            </Col>
          </>
        </Row>

        {showWaitModal ? (
            <WaitAndHoldModal
                show={showWaitModalPopup}
                handleClose={closeWaitModal}
                headerText="Hold request"
                buttonText="Ok"
                setShowWaitAndHoldModal={setShowWaitModal}
                resetForm={props.resetForm}
                resetFormDataEntryState={resetTransaction}
                holdForFacility={transactionDetails?.facility?.name}
                selectedHoldReasons={props.selectedHoldReasons}
                isReadonly={transactionDetails?.isReadOnly}
                closeReadOnlyModal={props.closeReadOnlyModal}
                getTransactionAttributes={getTransactionAttributes}
                transactionId={props.transactionId}
                facilityId={props.organizationId}
                loadUnwaitedTx={props.loadUnwaitedTx}
            />
        ) : null}
        {show ? (
            <RejectModal
                show={showModel}
                handleClose={closeModel}
                goLandingPage={goToHealthOrganization}
                rejectLetterData={props.rejectLetterData}
                resetForm={props.resetForm}
                resetFormDataEntryState={resetTransaction}
                readonly={transactionDetails!.isReadOnly}
            />
        ) : null}
        <Row>
          <ul className="nav nav-pills nav-fill">
            <Col
                lg={4}
                xs={4}
                md={4}
                className="nav-item"
                style={{paddingRight: "0px"}}
            >
              <span
                  className={
                    SelectedTabView === "Summary"
                        ? "nav-link first-tab active"
                        : "first-tab nav-link"
                  }
                  style={{borderRight: "none", cursor: 'pointer'}}
                  aria-current="page"
                  onClick={() => setSelectedTabView("Summary")}
              >
                Summary
              </span>
            </Col>
            <Col
                lg={4}
                xs={4}
                md={4}
                className="nav-item"
                style={{paddingLeft: "0px", paddingRight: "0px"}}
            >

              <LightTooltip
                  title={<>Past due tasks: {props.userTasks.filter(item => isPastDate(item.dueDate)).length}<br/>Total
                    tasks: {props.userTasks.length}</>} placement="top">
                  <span
                      className={
                        SelectedTabView === "Tasks"
                            ? "nav-link active task-tab"
                            : "nav-link task-tab"
                      }
                      onClick={() => setSelectedTabView("Tasks")}
                      style={{cursor: 'pointer'}}
                  >
                    Tasks ( <span
                      className="overdue-tasks">{props.userTasks.filter(item => isPastDate(item.dueDate)).length}</span> /{" "}
                    <span className="total-tasks">{props.userTasks.length}</span> )
                  </span>
              </LightTooltip>

            </Col>
            <Col
                lg={4}
                xs={4}
                md={4}
                className="nav-item"
                style={(props.QAFeatureFlags != null && props.QAFeatureFlags.finalQA ? {
                  paddingLeft: "0px",
                  paddingRight: "0px"
                } : {paddingLeft: "0px"})}>
              <span
                className={`nav-link ${SelectedTabView === "Audit" ? "active" : ""} ${props.QAFeatureFlags != null && props.QAFeatureFlags.finalQA ? "" : "last-tab"}`}
                style={(props.QAFeatureFlags != null && props.QAFeatureFlags.finalQA ? {
                  borderLeft: "none",
                  cursor: 'pointer',
                  borderRight: "none"
                } : {borderLeft: "none", cursor: 'pointer'})}
                onClick={() => setSelectedTabView("Audit")}
              >
                History
              </span>
            </Col>
            {props.QAFeatureFlags != null && props.QAFeatureFlags.finalQA && (<Col
              lg={4}
              xs={4}
              md={4}
              className="nav-item"
              style={{paddingLeft: "0px"}}
            >
              <LightTooltip
                title={<>Outstanding Issues: {qaIssues.filter((row) => (row.active && !row.resolved)).length}</>}
                placement="top"
              >
                <span
                  className={
                    SelectedTabView === "FinalQA"
                        ? "nav-link last-tab active"
                        : "last-tab nav-link"
                  }
                  style={{cursor: 'pointer'}}
                  onClick={() => setSelectedTabView("FinalQA")}
                >
                  Final QA {qaIssues.some((row) => (row.active && !row.resolved)) ? <span>( <span
                    className="final-qa-count"> {props.qaIssues.filter((row) => (row.active && !row.resolved)).length}</span> )</span> : ""}
                </span>
              </LightTooltip>
            </Col>)}
          </ul>
        </Row>
        <Row>
          <Col
            className={
              SelectedTabView === "Summary" ? "" : ""
            }
          />
        </Row>

        {SelectedTabView === "Summary" ? (
            <div className="leftBody tab-summary">
              <Row>
                <Col>
                <span className="section-headers">
                  {patientDetails?.contact?.firstName}{" "}
                  {patientDetails?.contact?.middleInitial ? patientDetails?.contact?.middleInitial + ' ' : patientDetails?.contact?.middleName ? patientDetails?.contact?.middleName.substr(0, 1) + ' ' : ' '}
                  {patientDetails?.contact?.lastName}
                </span>
                </Col>
                <Col className="text-right section-semi-headers" style={{right: "0px"}}>
                <span>
                  {patientDetails?.dob
                      ? moment(new Date(patientDetails?.dob)).format("MM/DD/YYYY")
                      : ""}
                </span>
                </Col>
              </Row>
              <Row className="margin-bottom">
                <Col>
                  <span className="section-semi-headers">MRN: </span><span>{props.transactionDetails?.mrn}</span>
                </Col>
                <Col>
                  <span
                      className="section-semi-headers">Case #: </span><span>{props.transactionDetails?.caseNumber}</span>
                </Col>
              </Row>
              {props.transactionDetails.facility.useRequestID && props.transactionDetails.requestID ?
                  <Row className="margin-bottom">
                    <Col>
                      <span
                          className="section-semi-headers">Release ID: </span><span>{props.transactionDetails.requestID}</span>
                    </Col>
                  </Row> : <></>}
              <div>
                <Row className='patient-notes-container' style={{display: (showPatientNotesDialog) ? 'none' : 'flex'}}>
                  <Col sm={11} className="pt-6 text-left">
                  <span className="patient-notes">
                    <span className="section-semi-headers">Patient Notes: </span>
                    {patientNotes &&
                        patientNotes.replaceAll &&
                        patientNotes.replaceAll("\n[ \t]*\n", "\n")}
                  </span>
                  </Col>
                  {!transactionDetails?.isReadOnly && props.transactionDetails?.patient?.id ?
                      <Col className="text-right px-0 right-alignment" sm={1}>
                        <img
                            className="cancelButton image-margin-reject edit-icon"
                            src={EditIcon}
                            alt="X"
                            onClick={patientNotesEditHandler}
                        />
                      </Col> : null}
                </Row>
                {showRejectCompletePopUp &&

                    toastPop(`${rejectNotificationType} \n
                This may take up to 20 seconds.`)
                }
                {showPatientNotesDialog && <div className='patient-notes-input'>
                  <Row>
                    <Col>
                      <textarea
                        className="dialog"
                        name="textarea"
                        value={patientNotesDialog}
                        onChange={patientNotesHandleChange}
                        maxLength={256}
                        ref={inputPatientNotes}
                      />
                    </Col>
                  </Row>
                  <Row className="text-right">
                    <Col>
                      <LightTooltip title="Cancel Notes" placement="right">
                        <span className="add-new-icon pointer-cursor cancel-task-icon" onKeyDown={k => {
                          k.key === 'Enter' && patientNotesEditHandler()
                        }} onClick={patientNotesEditHandler} tabIndex={0}>
                          <img src={crossIcon} alt={"undo save"}/>
                        </span>
                      </LightTooltip>

                      <LightTooltip title="Save Notes" placement="right">
                        <span className="add-new-icon pointer-cursor save-task-icon" onKeyDown={k => {
                          k.key === 'Enter' && textDialogOnBlurPatient()
                        }} onClick={textDialogOnBlurPatient} tabIndex={0}>
                          <img src={checkIcon} alt={"Save Comment"}/>
                        </span>
                      </LightTooltip>
                    </Col>
                  </Row>
                </div>}
              </div>

              <Row>
                <Col className="bottom-border margin-bottom"/>
              </Row>
              <Row>

                <Col xs={12} md={12} sm={12} lg={12} className="section-headers">
                  Requestor Information:
                </Col>

                <Col className="text-left">
                  <span>{requestorDetails?.fullName}</span>
                </Col>
              </Row>
              <Row>
                <Col>
                <span className="">
                  {requestorDetails?.requestorInfo?.firstName}{" "}
                  {requestorDetails?.requestorInfo?.lastName}
                </span>
                </Col>
                {requestorDetails?.requestorInfo?.isVerified ? (
                    <Col className="text-right" style={{right: "0px"}}>
                      <img
                          className="cancelButton image-margin-reject edit-icon"
                          src={CheckMarkFilled}
                          alt="X"
                      />
                      <span className="verified-text">VERIFIED</span>
                    </Col>
                ) : null}
              </Row>
              <Row>
                <Col>
                <span className="text-left">
                  {requestorDetails?.requestorAddress?.address1}
                  {" "}
                  {requestorDetails?.requestorAddress?.address2}
                </span>
                </Col>
              </Row>
              <Row className="margin-bottom">
                <Col className="text-left">
                <span>
                  {requestorDetails?.requestorAddress?.city}
                  {requestorDetails?.requestorAddress?.city &&
                  requestorDetails?.requestorAddress?.state
                      ? ","
                      : ""}
                  {requestorDetails?.requestorAddress?.state}{" "}
                  {requestorDetails?.requestorAddress?.zipCode}
                </span>
                </Col>
              </Row>
              <Row>
                <Col>
                  {requestorDetails?.requestorInfo?.phone && <>
                  <span className="text-left">
                    <abbr title="Phone Number">P</abbr>: {normalizePhone(requestorDetails.requestorInfo.phone)}
                  </span>
                    {requestorDetails.requestorInfo.fax && <br/>}
                  </>}
                  {requestorDetails?.requestorInfo?.fax && <span className="text-left">
                  <abbr title="Fax Number">F</abbr>: {normalizePhone(requestorDetails.requestorInfo.fax)}
                </span>}
                </Col>
              </Row>
              <Col className="text-left" style={{paddingLeft: "0px"}}>
                <span>{requestorDetails?.requestorInfo?.email}</span>
              </Col>
              <Row></Row>
              <Row className="margin-bottom" style={{display: showRequestorNotesDialog ? 'none' : 'flex'}}>
                <Col sm={11} className="pt-6 text-left">
                <span className="requestor-notes">
                  <span className="section-semi-headers">Requestor Notes: </span>
                  {requestorNotes &&
                      requestorNotes.replaceAll &&
                      requestorNotes.replaceAll("\n[ \t]*\n", "\n")}
                </span>
                </Col>
                {!transactionDetails?.isReadOnly && props.requestorDetails?.requestorID ?
                    <Col className="text-right px-0 right-alignment" sm={1}>
                      <img
                          className="cancelButton image-margin-reject edit-icon"
                          src={EditIcon}
                          alt="X"
                          onClick={requestorNotesEditHandler}
                      />
                    </Col> : null}
              </Row>
              {showRequestorNotesDialog && (
                  <div>
                    <Row>
                      <Col>
                    <textarea
                        className="dialog"
                        name="textarea"
                        value={requestorNotesDialog}
                        onChange={requestorNotesHandleChange}
                        maxLength={256}
                        ref={inputRequestorNotes}
                    />
                      </Col>
                    </Row>
                    <Row className="text-right">
                      <Col>
                        <LightTooltip title="Cancel Notes" placement="right">
                      <span onClick={requestorNotesEditHandler} onKeyDown={k => {
                        k.key === 'Enter' && requestorNotesEditHandler()
                      }} className="add-new-icon pointer-cursor cancel-task-icon" tabIndex={0}>
                        <img src={crossIcon} alt={"undo save"}/>
                      </span>
                        </LightTooltip>

                        <LightTooltip title="Save Notes" placement="right">
                      <span onClick={textDialogOnBlurRequestor} onKeyDown={k => {
                        k.key === 'Enter' && textDialogOnBlurRequestor()
                      }} className="add-new-icon pointer-cursor save-task-icon" tabIndex={0}>
                        <img src={checkIcon} alt={"Save Comment"}/>
                      </span>
                        </LightTooltip>

                      </Col>
                    </Row>
                  </div>
              )}

              <Row>
                <Col className="bottom-border margin-bottom"/>
              </Row>

              <Row>
                <Col>
                <span className="section-headers">
                  Request Status
                </span>
                </Col>
                {((transactionDetails.isReadOnly || transactionDetails.transactionStatus.id >= 130 && transactionDetails.transactionStatus.id <= 141) && props.selectedHoldReasons && props.selectedHoldReasons.length === 0) ? <></> :
                    <Col className="text-right section-semi-headers" style={{right: "0px"}}>
                  <span onClick={showWaitModalPopup}>
                    {props.selectedHoldReasons && props.selectedHoldReasons.length > 0 ? (
                        <>
                          <i className="fa fa-play" aria-hidden="true"></i>
                          <span className="span-paused">STOP HOLD</span>
                        </>
                    ) : (
                        <>
                          <i className="fa fa-pause" aria-hidden="true"></i>
                          <span className="span-paused">START HOLD</span>
                        </>
                    )}
                  </span>
                    </Col>
                }
              </Row>
              <Row>
                <Col>
                  <div className="text-left">
                    {requestTypeText}
                  </div>
                </Col>
                <Col className="text-right" style={{right: "0px"}}>
                  {props.transactionDetails.disclosingInstitution?.name && <div>
                    {(transactionDetails.facility.useClinics ? "Clinic: " : "Department: ") + props.transactionDetails.disclosingInstitution?.name}
                  </div>}
                  <div>{transactionDetails.transactionStatus.name}</div>
                  {[1, 2].includes(transactionDetails.tableID) && transactionDetails.transactionStatus.id <= 138 && transactionDetails.requestPurpose?.typeID != 66 &&
                      <div className="nopadding">
                        <CheckboxField
                            fieldlabel=""
                            onChange={onChangeEscalation}
                            defaultChecked={props.transactionDetails.isEscalated}
                            errMsg=""
                            checkboxLabel={'Escalate for QA Review'}
                        />
                      </div>}
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className="text-left">
                    {props.transactionDetails?.accessCode && <>
                      {props.trackingLink ?
                          (<a style={{fontSize: "14px"}} target="_blank" rel="noreferrer"
                              href={props.trackingLink + "/trackrequest/track/?ids=" + props.transactionDetails.accessCode}>
                            {props.transactionDetails.accessCode}
                          </a>)
                          :
                          props.transactionDetails.accessCode
                      }
                      &nbsp;
                      <CopyToClipboard copyText={props.transactionDetails.accessCode}/>
                    </>}
                  </div>
                </Col>
                <Col className="text-right" style={{right: "0px"}}>
                  {props.requestorBillingDetails?.prePay && <span
                      className="section-semi-headers"
                      style={{lineHeight: "34px"}}
                  >
                  Prepay
                </span>}
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className="text-left">
                    {props.transactionDetails?.releaseMethod?.name && "Release Method: " + props.transactionDetails.releaseMethod.name}
                  </div>
                </Col>
                <Col className="text-right" style={{right: "0px"}}>
                  {props.transactionDetails?.facility && documentStates.some(x => x != props.transactionDetails.facility.address.state) &&
                      <div>
                        <span className="section-semi-headers">Multi State</span>
                        <br/>
                        {documentStates.join(", ")}
                      </div>}
                </Col>
              </Row>
              <Row>
                <Col className="bottom-border margin-bottom"/>
              </Row>
              {transactionDetails.isReadOnly && !transactionDetails?.transactionRequest?.isDisclosureRequest ?
                  (<>
                    <Row>
                      <Col xs={12} md={12} sm={12} lg={12} className="section-headers">Billing Information</Col>
                    </Row>
                    {transactionDetails?.feeSchedule?.name ?
                        <Row>
                          <Col>
                            <div className="transaction-row-info">Fee Schedule:</div>
                            <div>{transactionDetails?.feeSchedule.name}</div>
                          </Col>
                        </Row> : <></>}
                    <Row>
                      <Col className="transaction-row-section">
                        <Row>
                          <Col>
                            <div className="transaction-row-info">Invoice Amount</div>
                            <div>{formatter.format(transactionDetails?.invoiceAmount)}</div>
                          </Col>
                          {transactionDetails?.paidAmount && (transactionDetails?.invoiceAmount !== transactionDetails?.paidAmount) ?
                              <Col>
                                <div className="transaction-row-info">Partially Paid</div>
                                <div>{formatter.format(transactionDetails?.paidAmount)}</div>
                              </Col> : <></>}
                        </Row>
                        {transactionDetails?.payments.length > 0 ?
                            <>
                              <Row className="payment-highlight">
                                <Col>
                                  <div className="transaction-row-info">Payments</div>
                                </Col>
                              </Row>
                              {transactionDetails?.payments.filter(p => p.paymentAmount !== 0).map((p, i) =>
                                  <Row className="payment-highlight">
                                    <Col>{getMomentDate(p.date)}</Col>
                                    <Col>
                                      <div>Amount: {formatter.format(p.paymentAmount)}</div>
                                      <div>Check #: {p.checkNum}</div>
                                      {p.firstName || p.lastName ?
                                          <div>Payor Name: {p.firstName + " " + p.lastName}</div> : null}
                                      {p.ccEmail ? <div>Email: {p.ccEmail}</div> : null}
                                    </Col>
                                  </Row>
                              )}
                            </>
                            : <></>
                        }
                        {sendToBillToSame() ? null :
                            <>
                              <Row>
                                <Col>
                                  <div className="transaction-row-info">Bill To Information</div>
                                </Col>
                              </Row>
                              {values ? (<Row>
                                <Col>
                                  {values[BillingFormconstants.BILL_TO_REQUESTOR_NAME] ? (
                                      <div>{values[BillingFormconstants.BILL_TO_REQUESTOR_NAME]}</div>) : null}
                                  {values[BillingFormconstants.BILL_TO_ADDRESS_LINE1] ? (
                                      <div>{values[BillingFormconstants.BILL_TO_ADDRESS_LINE1]}</div>) : null}
                                  {values[BillingFormconstants.BILL_TO_ADDRESS_LINE2] ? (
                                      <div>{values[BillingFormconstants.BILL_TO_ADDRESS_LINE2]}</div>) : null}
                                  {values[BillingFormconstants.BILL_TO_CITY] || values[BillingFormconstants.BILL_TO_STATE] || values[BillingFormconstants.BILL_TO_ZIP] ? (
                                      <div>
                                        {values[BillingFormconstants.BILL_TO_CITY] ? values[BillingFormconstants.BILL_TO_CITY] : null},&nbsp;
                                        {values[BillingFormconstants.BILL_TO_STATE] ? values[BillingFormconstants.BILL_TO_STATE] : null}&nbsp;
                                        {values[BillingFormconstants.BILL_TO_ZIP] ? values[BillingFormconstants.BILL_TO_ZIP] : null}
                                      </div>) : null}
                                  {values[BillingFormconstants.BILL_TO_PHONE] ? (
                                      <div>{normalizePhone(values[BillingFormconstants.BILL_TO_PHONE])}</div>) : null}
                                </Col>
                                <Col>
                                  {values[BillingFormconstants.BILL_TO_FAX] ? (
                                      <div>{values[BillingFormconstants.BILL_TO_FAX]}</div>) : null}
                                  {values[BillingFormconstants.BILL_TO_EMAIL_ADDRESS] ? (
                                      <div>{values[BillingFormconstants.BILL_TO_EMAIL_ADDRESS]}</div>) : null}
                                  {values[BillingFormconstants.BILL_TO_FIRST_NAME] ? (
                                      <div>{values[BillingFormconstants.BILL_TO_FIRST_NAME]}</div>) : null}
                                  {values[BillingFormconstants.BILL_TO_LAST_NAME] ? (
                                      <div>{values[BillingFormconstants.BILL_TO_LAST_NAME]}</div>) : null}
                                </Col>
                              </Row>) : null}
                            </>}
                      </Col>
                    </Row>
                    <Row>
                      <Col className="bottom-border margin-bottom"/>
                    </Row>
                  </>) : (<></>)}
              <Row>
                <Col xs={12} md={12} sm={12} lg={12} className="section-headers">
                  Information To Release:
                </Col>
              </Row>
              {allDates ?
                <Row>
                  <Col xs={12} md={12} sm={12} lg={12}>
                    All Dates
                  </Col>
                </Row>
                :
                <Row>
                  <Col xs={6} md={6} sm={6} lg={6} className="">
                    <span className="itr-dt-label">From: </span>
                    <span className="itr-from-dt">
                      {getMomentDate(informationToReleaseFromValues)}
                    </span>
                  </Col>
                  <Col xs={6} md={6} sm={6} lg={6} className="">
                    <span className="itr-dt-label">To: </span>
                    <span className="itr-to-dt">
                      {getMomentDate(informationToReleaseToValues)}
                    </span>
                  </Col>
                </Row>
              }
              <Row className="sensitive-info-sec">
                {/* AB#39380: the shared mapper, not a fourth hand-rolled copy of "is there a
                    description and which record type does it belong to" - this pane, the Quick
                    Entry row and the Records pane must not disagree, and it is the surface the
                    other two are matched against (Mike Hamilton, PR !10721 round 4). It also
                    drops the dangling "Other Documents - " this rendered when the type was
                    requested with no text. */}
                {recordsRequestedDisplayNames(transactionDetails.releaseInfo, transactionDetails.requestComments)
                  .map((recordText, index) => <Col
                  xs={6}
                  md={6}
                  lg={6}
                  sm={6}
                  key={index}
                  className="sensitive-info-display records-requested-item"
                >
                  <span className="check-icon">
                    <img src={checkMarkImage} alt="X"/>
                  </span>
                  {/* Clamped for the same reason the other two surfaces are: the box behind the
                      description takes 2,000 characters, and unclamped it pushes Sensitive
                      Information and everything below it off the pane. Full text on the tooltip. */}
                  <span className="records-requested-text" title={recordText}>{recordText}</span>
                </Col>)}
              </Row>
              <Row>
                <Col className="bottom-border margin-bottom"/>
              </Row>
              {!transactionDetails?.transactionRequest?.isDisclosureRequest ?
                  (<>
                    <Row>
                      <Col xs={12} md={12} sm={12} lg={12} className="name section-headers">
                        Sensitive Information:
                      </Col>
                    </Row>
                    <Row className="sensitive-info-sec">
                      {allSensitiveInfoValues.map((item) => <Col
                        xs={6}
                        md={6}
                        lg={6}
                        sm={6}
                        className="sensitive-info-display"
                      >
                        {renderSensitiveInfoItem(item)}
                      </Col>)}
                    </Row>
                    <Row>
                      <Col className="bottom-border margin-bottom"/>
                    </Row>
                  </>) : (<></>)}
              <div className="date-style">
                <Row>
                  <Col sm={5}>
                    <span>Auth Date:</span>
                  </Col>
                  <Col sm={2} className="p-0">
                  <span>
                    {getMomentDate(transactionDetails.date?.authorization)}
                  </span>
                  </Col>
                  <Col sm={5} className="text-right text-align-right">
                  <span>
                    {getDaysDiff(transactionDetails.date?.authorization)}
                  </span>
                  </Col>
                </Row>
                <Row>
                  <Col sm={5}>
                    <span>Request Date:</span>
                  </Col>
                  <Col sm={2} className="p-0">
                    <span>{getMomentDate(transactionDetails.date?.request)}</span>
                  </Col>
                  <Col sm={5} className="text-right text-align-right">
                    <span>{getDaysDiff(transactionDetails.date?.request)}</span>
                  </Col>
                </Row>
                <Row>
                  <Col sm={5}>
                    <span>Received Date:</span>
                  </Col>
                  <Col sm={2} className="p-0">
                  <span>
                    {getMomentDate(transactionDetails.date?.received)}
                  </span>
                  </Col>
                  <Col sm={5} className="text-right text-align-right">
                    <span>{getDaysDiff(transactionDetails.date?.received)}</span>
                  </Col>
                </Row>
                <Row>
                  <Col sm={5}>
                    <span>Entered Date:</span>
                  </Col>
                  <Col sm={2} className="p-0">
                    <span>{getMomentDate(transactionDetails.date?.entry)}</span>
                  </Col>
                  <Col sm={5} className="text-right text-align-right">
                    <span>{getDaysDiff(transactionDetails.date?.entry)}</span>
                  </Col>
                </Row>
                <Row className="margin-bottom">
                  <Col sm={5}>
                    <span>Due Date:</span>
                  </Col>
                  <Col sm={2} className="p-0">
                    <span>{getMomentDate(transactionDetails.date?.due)}</span>
                  </Col>
                  <Col sm={5} className="text-right text-align-right">
                    <span>{getDaysDiff(transactionDetails.date?.due)}</span>
                  </Col>
                </Row>
              </div>
              <Row>
                <Col>
                  <span>Certification Requested: {props.transactionDetails.certificationRequired ? 'Yes' : 'No'}</span>
                </Col>
              </Row>
              <Row className="margin-bottom"/>
              <Row>
                <Col className="bottom-border margin-bottom"/>
              </Row>
              <NewTransactionNotesTable
                  rows={transactionNotes}
                  setGrid={setShowGrid}
                  transactionNoteTypes={props.transactionNoteTypes}
                  updateTransactionNotes={props.updateTransactionNotes}
                  transactionId={props.transactionId}
              />
              <Row className="transaction-notes-section">
                <Col>
                  {transactionNotes.map(
                      (row) => {
                        let fullName = row.createdByName.split(' ');
                        return (
                            <>
                              <Row className="transaction-row-section">
                                <Col className='transaction-row-info'>
                                  <div>{getMomentDate(row.created, "MM/DD/YYYY h:mm A")}</div>
                                  <div>{fullName[fullName.length - 1] + ", " + fullName[0]}</div>
                                </Col>
                                <div>{row.type?.name}</div>
                                <Col className='transaction-row-text'>
                                  <div>{row.text}</div>
                                </Col>
                              </Row>
                              <Row className="extra-line"></Row>
                            </>

                        );
                      }
                  )}
                </Col>
              </Row>
            </div>
        ) : SelectedTabView === "Tasks" ? (
            <div className="leftBody tab-tasks">
              <Row>
                <Col>
                  <a
                      href="#!"
                      className={createTaskStatus || editingTaskId !== 0 ? "addtaskstyles" : "empty-css"}
                      onClick={initiateCreateNewTask}
                  >
                    <img
                        src={AddNewRequestor}
                        alt={"Add Task"}
                        className="add-new-icon"
                    />
                    <span className="">{"Add Task"}</span>
                  </a>
                </Col>
              </Row>


              {showDeleteTaskPopUp ?
                  <DeleteTaskPopUp
                      setDeleteTaskPopUp={setDeleteTaskPopUp}
                      getConfirmation={getConfirmation}
                  />
                  : null}

              {createTaskStatus ?
                  <NewTask
                      updateTask={props.updateTask}
                      transactionId={props.transactionId}
                      addNewTask={props.addNewTask}
                      createUserTaskComment={props.createUserTaskComment}
                      userAttributes={props.userAttributes}
                      editingTaskId={editingTaskId}
                      userGroups={props.userGroups}
                      updateUserTaskComments={props.updateUserTaskComments}
                      updateUserTasks={props.updateUserTasks}
                      userTaskComments={props.userTaskComments}
                      isNewTask={true}
                      setEditingTaskId={setEditingTaskId}
                      updateCreateTaskStatus={updateCreateTaskStatus}
                  />
                  : null}

              {props.userTasks.map((task, index) => {
                if (task.id === editingTaskId) {
                  return <NewTask updateTask={props.updateTask} transactionId={props.transactionId}
                                  addNewTask={props.addNewTask} createUserTaskComment={props.createUserTaskComment}
                                  userAttributes={props.userAttributes} editingTaskId={editingTaskId}
                                  setEditingTaskId={setEditingTaskId} updateCreateTaskStatus={updateCreateTaskStatus}
                                  userTaskComments={props.userTaskComments}
                                  updateUserTaskComments={props.updateUserTaskComments}
                                  updateUserTasks={props.updateUserTasks}
                                  userGroups={props.userGroups} taskDetails={task} index={index}/>
                } else {
                  return <NewTaskCollapsed updateTask={props.updateTask} transactionId={props.transactionId}
                                           userGroups={props.userGroups} userAttributes={props.userAttributes}
                                           editingTaskId={editingTaskId} setEditingTaskId={setEditingTaskId}
                                           updateCreateTaskStatus={updateCreateTaskStatus}
                                           userTaskComments={props.userTaskComments} taskDetails={task} index={index}
                                           updateUserTaskComments={props.updateUserTaskComments}
                                           updateUserTasks={props.updateUserTasks}
                                           setDeleteTaskPopUp={setDeleteTaskPopUp}
                                           deleteTaskbyId={deleteTaskbyId}/>
                }
              })
              }
            </div>
        ) : SelectedTabView === "Audit" ? (
            <div className="leftBody tab-audit">
              {(props.auditTrail || []).map((d, i) => {
                return [i > 0 ? (<hr/>) : (<></>),
                  (<DisplayAuditItem auditData={d}/>)]
              })}
            </div>
        ) : SelectedTabView === "FinalQA" && props.QAFeatureFlags != null && props.QAFeatureFlags.finalQA ? (
            <div className="leftBody tab-finalqa">
              {props.QAFeatureFlags?.finalQAAccordions && assessmentResult && entityTypes && entityTypes.length > 0 && props.transactionDetails.isInAIProcessing && !props.transactionDetails.aiProcessingFailed && <div>
                {/* No inline colour -- .section-headers is themed in SCSS
                    (index.scss uses $link-color-dark in dark theme). The inline
                    light-surface blue used to win over that and measured 2.30:1. */}
                <span className="section-headers">AI Findings</span>
                <Accordion>
                  <Card>
                    <Accordion.Toggle className="section-semi-headers" as={Card.Header} variant="link" eventKey="0">
                      Sensitive Information
                      {props.transactionDetails.aiProcessingCompleted ?
                        <div className="fa-stack ai-processing-icon" title="AI processing results">
                          <i className="fa fa-circle fa-stack-2x" aria-hidden="true"></i>
                          <span className="fa-stack-1x ai-results-num">
                            {getAIEntityCount(assessmentResult, "sensitive", props.QAFeatureFlags?.finalQAShowCominglingNames, props.authorizedEntities)}
                          </span>
                        </div>
                        :
                        <img
                          src={aiProcessingIcon}
                          className="ai-processing-icon"
                          title="AI processing not yet completed"
                          alt="AI processing not yet completed"
                        />
                      }
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey="0">
                      <Card.Body>
                        <div
                          className="d-inline-flex flex-row"
                          style={{height: "14px"}}
                          title="Show all found sensitive information below, even if it was authorized to be released."
                        >
                          <input
                              type="checkbox"
                              className="checkbox-eye-openunchecked"
                              id="show-authorized-entities"
                              checked={showAuthorizedEntities}
                              onChange={event => setShowAuthorizedEntities(event.target.checked)}
                          />
                          <label htmlFor="show-authorized-entities">{showAuthorizedEntities ? "Hide" : "Show"} Authorized</label>
                        </div>
                        <hr/>
                        <div className="issue-block">
                          <div className="issue-info">
                            {!transactionDetails.facility.prohibitTraining && (
                              <div className="checkbox-col issue-underline">
                                <input
                                  type="checkbox"
                                  checked={
                                    assessmentResult.detectedEntities
                                      .filter(ent => ent.type.toLowerCase() != RELEASE && shouldShowEntity(ent) && !ent.feedback)
                                      .length > 0 &&
                                    assessmentResult.detectedEntities
                                      .filter(ent => ent.type.toLowerCase() != RELEASE && shouldShowEntity(ent) && !ent.feedback)
                                      .every(ent => selectedEntityIds.has(ent.id))
                                  }
                                  onChange={() => {
                                    const entities = assessmentResult.detectedEntities
                                      .filter(ent => ent.type.toLowerCase() != RELEASE && shouldShowEntity(ent) && !ent.feedback);
                                    toggleSelectAll(entities);
                                  }}
                                  title="Select/Deselect all findings"
                                />
                              </div>
                            )}
                            <div className="text-col issue-underline">
                              Text
                            </div>
                            <div className="type-col issue-underline">
                              Type
                            </div>
                            <div className="page-col issue-underline">
                              Page
                            </div>
                            <div className="confidence-col issue-underline">
                              Confidence
                            </div>
                          </div>
                          {assessmentResult.detectedEntities.filter(ent =>
                            ent.type.toLowerCase() != RELEASE
                          ).filter(shouldShowEntity).map(ent => {
                            const type = entityTypes?.find(x => x.id == ent.type);
                            if (!type) return null;
                            return <>
                              <div className="issue-info">
                                {!transactionDetails.facility.prohibitTraining && (
                                  <div className="checkbox-col">
                                    <input
                                      type="checkbox"
                                      checked={selectedEntityIds.has(ent.id)}
                                      onChange={() => toggleEntitySelection(ent.id)}
                                      disabled={!!ent.feedback}
                                      title={ent.feedback ? "Cannot select finding with existing feedback" : "Select finding"}
                                    />
                                  </div>
                                )}
                                <div className="text-col">
                                  <span>{ent.spanText}</span>
                                </div>
                                <div className="type-col">
                                  <span>
                                    {type.name}
                                    <i className="fa fa-square fa-border fa-pull-left"
                                        style={{color: type.color}} title="Annotation Color"></i>
                                  </span>
                                </div>
                                <div className="page-col">
                                  <span
                                    role="button"
                                    className="themed-link"
                                    onClick={() => handlePageClick(ent.page + 1, qaDocDesc)}
                                  >
                                    {ent.page + 1}
                                  </span>
                                </div>
                                <div className="confidence-col">
                                  <span>
                                    {(ent.confidence * 100.0).toFixed(2)}%
                                  </span>
                                </div>
                              </div>
                              {!transactionDetails.facility.prohibitTraining && <div className="issue-actions">
                                {ent.feedback ? <>
                                  <div className="feedback-name">
                                    <span>
                                      {props.aiFeedback?.find(fb => fb.id == ent.feedback)?.name}
                                    </span>
                                  </div>
                                  <div className="vr"></div>
                                  {<button
                                    className="issue-action-button themed-link"
                                    type="button"
                                    disabled={ent.feedbackAccepted}
                                    onClick={() => undoFeedback(ent.id)}
                                    title={ent.feedbackAccepted ? "Your feedback has been accepted by an administrator and can no longer be undone." : "Undo Feedback Submission"}
                                  >
                                    <div className="fa fa-undo" aria-hidden="true"></div>
                                    <span>Undo Feedback</span>
                                  </button>}
                                </> : <>
                                  <button
                                    className="issue-action-button"
                                    type="button"
                                    disabled={submittingEntityIds.has(ent.id)}
                                    onClick={() => addFeedback(ent.id, CORRECT_FEEDBACK)}
                                    title="Confirm as correct"
                                  >
                                    <img src={CheckMarkFilled} alt="" />
                                    <span style={{color: "#63B96C"}}>Confirm Finding</span>
                                  </button>
                                  <div className="vr"></div>
                                  <button
                                    className="issue-action-button"
                                    type="button"
                                    disabled={submittingEntityIds.has(ent.id)}
                                    onClick={() => onIncorrectFeedbackClicked(ent)}
                                    title="Reject as incorrect"
                                  >
                                    <img src={CancelMarkFilled} alt="" />
                                    <span className="themed-reject">Reject Finding</span>
                                  </button>
                                </>}
                              </div>}
                              <hr/>
                            </>
                          })}
                        </div>
                     </Card.Body>
                    </Accordion.Collapse>
                  </Card>
                </Accordion>
                <Accordion>
                  <Card>
                    <Accordion.Toggle className="section-semi-headers" as={Card.Header} variant="link" eventKey="1">
                   Comingling
                      {props.transactionDetails.aiProcessingCompleted ?
                        <div className="fa-stack ai-processing-icon" title="AI processing results">
                          <i className="fa fa-circle fa-stack-2x" aria-hidden="true"></i>
                          <span className="fa-stack-1x ai-results-num">
                            {getAIEntityCount(assessmentResult, "patient", props.QAFeatureFlags?.finalQAShowCominglingNames)}
                          </span>
                        </div>
                        :
                        <img
                          src={aiProcessingIcon}
                          className="ai-processing-icon"
                          title="AI processing not yet completed"
                          alt="AI processing not yet completed"
                        />
                      }
                   </Accordion.Toggle>
                  
                    <Accordion.Collapse eventKey="1">
                      <Card.Body>
                           { props.QAFeatureFlags?.finalQAShowCominglingNames === true && 
                        <div>
                          {/* --- SECTION 1: Detected Patient Names --- */}
                          <h6 className="subsection-header">Comingled Patient Names</h6>
                          <div className="issue-block">
                            <div className="issue-info">
 
                              <div className="name-col issue-underline">Name</div>
                              <div className="page-col issue-underline">Page</div>
                              <div className="confidence-col issue-underline">Confidence</div>
                            </div>

                            {Object.keys(assessmentResult.patientNames).map((name) => (
                              <>
                                {assessmentResult.patientNames[name].map((patient) => (
                                  <>
                                    <div className="issue-info">
                                      <div className="name-col">
                                        <span>{patient.spanText}</span>
                                      </div>
                                      <div className="page-col">
                                        <span
                                          role="button"
                                          className="themed-link"
                                          onClick={() => handlePageClick(patient.page + 1, qaDocDesc)}
                                        >
                                          {patient.page + 1}
                                        </span>
                                      </div>
                                      <div className="confidence-col">
                                        <span>{(patient.confidence * 100.0).toFixed(2)}%</span>
                                      </div>
                                    </div>

                                    {!transactionDetails.facility.prohibitTraining && (
                                      <div className="issue-actions">
                                        {patient.feedback ? (
                                          <>
                                            <div className="feedback-name">
                                              <span>
                                                {props.aiFeedback?.find((fb) => fb.id == patient.feedback)?.name}
                                              </span>
                                            </div>
                                            <div className="vr"></div>
                                            <button
                                              type="button"
                                              className="issue-action-button themed-link"
                                              disabled={patient.feedbackAccepted}
                                              onClick={() => undoFeedback(patient.id)}
                                              title={
                                                patient.feedbackAccepted
                                                  ? "Your feedback has been accepted by an administrator and can no longer be undone."
                                                  : "Undo Feedback Submission"
                                              }
                                            >
                                              <div className="fa fa-undo" aria-hidden="true"></div>
                                              <span>Undo Feedback</span>
                                            </button>
                                          </>
                                        ) : (
                                          <>
                                            <button
                                              type="button"
                                              className="issue-action-button"
                                              disabled={submittingEntityIds.has(patient.id)}
                                              onClick={() => addFeedback(patient.id, CORRECT_FEEDBACK)}
                                              title="Confirm as correct"
                                            >
                                              <img src={CheckMarkFilled} alt="" />
                                              <span style={{ color: "#63B96C" }}>Confirm Finding</span>
                                            </button>
                                            <div className="vr"></div>
                                            <button
                                              type="button"
                                              className="issue-action-button"
                                              disabled={submittingEntityIds.has(patient.id)}
                                              onClick={() => onIncorrectFeedbackClicked(patient)}
                                              title="Reject as incorrect"
                                            >
                                              <img src={CancelMarkFilled} alt="" />
                                              <span className="themed-reject">Reject Finding</span>
                                            </button>
                                          </>
                                        )}
                                      </div>
                                    )}
                                    <hr />
                                  </>
                                ))}
                              </>
                            ))}
                          </div>
                        </div>
                        }
                        {/* --- SECTION 2: Pages Missing Patient Names --- */}
                        <h6 className="subsection-header" style={{ marginTop: "1.5rem" }}>
                          Pages Missing Patient Names
                        </h6>


                        {assessmentResult?.patientNameMissingPages && Object.keys(assessmentResult.patientNameMissingPages).length > 0 ? (
                          <div className="issue-block">
                            <div className="issue-info">
                              <div className="page-col issue-underline">Page</div>
                            </div>

                            {Object.keys(assessmentResult.patientNameMissingPages).map((page) => (
                              <>
                               {assessmentResult.patientNameMissingPages[page].map((patient) => (
                                <>
                              <div key={patient.id} className="issue-info">
                                <div className="page-col">
                                  <span
                                    role="button"
                                    className="themed-link"
                                    onClick={() => handlePageClick(patient.page + 1, qaDocDesc)}
                                  >
                                    {"Pg " + (patient.page + 1)}
                                  </span>
                                </div>
                              </div>
                                {!transactionDetails.facility.prohibitTraining && (
                                      <div className="issue-actions">
                                        {patient.feedback ? (
                                          <>
                                            <div className="feedback-name">
                                              <span>
                                                {props.aiFeedback?.find((fb) => fb.id == patient.feedback)?.name}
                                              </span>
                                            </div>
                                            <div className="vr"></div>
                                            <button
                                              type="button"
                                              className="issue-action-button themed-link"
                                              disabled={patient.feedbackAccepted}
                                              onClick={() => undoFeedback(patient.id)}
                                              title={
                                                patient.feedbackAccepted
                                                  ? "Your feedback has been accepted by an administrator and can no longer be undone."
                                                  : "Undo Feedback Submission"
                                              }
                                            >
                                              <div className="fa fa-undo" aria-hidden="true"></div>
                                              <span>Undo Feedback</span>
                                            </button>
                                          </>
                                        ) : (
                                          <>
                                            <button
                                              type="button"
                                              className="issue-action-button"
                                              disabled={submittingEntityIds.has(patient.id)}
                                              onClick={() => addFeedback(patient.id, CORRECT_FEEDBACK)}
                                              title="Confirm as correct"
                                            >
                                              <img src={CheckMarkFilled} alt="" />
                                              <span style={{ color: "#63B96C" }}>Confirm Finding</span>
                                            </button>
                                            <div className="vr"></div>
                                            <button
                                              type="button"
                                              className="issue-action-button"
                                              disabled={submittingEntityIds.has(patient.id)}
                                              onClick={() => onIncorrectFeedbackClicked(patient)}
                                              title="Reject as incorrect"
                                            >
                                              <img src={CancelMarkFilled} alt="" />
                                              <span className="themed-reject">Reject Finding</span>
                                            </button>
                                          </>
                                        )}
                                      </div>
                                  )}
                                  </>
                                ))}
                               </>    
                            ))}
                          </div>
                        ) : (
                          <div style={{ fontStyle: "italic", color: "#666" }}>
                            No pages with missing patient names found.
                          </div>
                        )}
                    </Card.Body>
                    </Accordion.Collapse>
                  </Card>
                </Accordion>
                <Accordion>
                  <Card>
                    <Accordion.Toggle className="section-semi-headers" as={Card.Header} variant="link" eventKey="2">
                      Patient Auth
                      {props.transactionDetails.aiProcessingCompleted ?
                        <div className="fa-stack ai-processing-icon" title="AI processing results">
                          <i className="fa fa-circle fa-stack-2x" aria-hidden="true"></i>
                          <span className="fa-stack-1x ai-results-num">
                            {getAIEntityCount(assessmentResult, "auth", props.QAFeatureFlags?.finalQAShowCominglingNames)}
                          </span>
                        </div>
                        :
                        <img
                          src={aiProcessingIcon}
                          className="ai-processing-icon"
                          title="AI processing not yet completed"
                          alt="AI processing not yet completed"
                        />
                      }
                     </Accordion.Toggle>
                    <Accordion.Collapse eventKey="2">
                      <Card.Body>
                        <div className="issue-block">
                          <div className="issue-info">
                            <div className="name-col issue-underline">
                            </div>
                            <div className="page-col issue-underline">
                              Page
                            </div>
                            <div className="confidence-col issue-underline">
                              Confidence
                            </div>
                          </div>
                          {assessmentResult.detectedEntities.filter(ent =>
                            ent.type.toLowerCase() == RELEASE
                          ).map(auth => <>
                            <div className="issue-info">
                              <div className="name-col">
                              </div>
                              <div className="page-col">
                                <span
                                  role="button"
                                  className="themed-link"
                                  onClick={() => handlePageClick(auth.page + 1, qaDocDesc)}
                                >
                                  {auth.page + 1}
                                </span>
                              </div>
                              <div className="confidence-col">
                                <span>
                                  {(auth.confidence * 100.0).toFixed(2)}%
                                </span>
                              </div>
                            </div>
                            {!transactionDetails.facility.prohibitTraining && <div className="issue-actions">
                              {auth.feedback ? <>
                                <div className="feedback-name">
                                  <span>
                                    {props.aiFeedback?.find(fb => fb.id == auth.feedback)?.name}
                                  </span>
                                </div>
                                <div className="vr"></div>
                                <button
                                  type="button"
                                  className="issue-action-button themed-link"
                                  disabled={auth.feedbackAccepted}
                                  onClick={() => undoFeedback(auth.id)}
                                  title={auth.feedbackAccepted ? "Your feedback has been accepted by an administrator and can no longer be undone." : "Undo Feedback Submission"}
                                >
                                  <div className="fa fa-undo" aria-hidden="true"></div>
                                  <span>Undo Feedback</span>
                                </button>
                              </> : <>
                                <button
                                  type="button"
                                  className="issue-action-button"
                                  disabled={submittingEntityIds.has(auth.id)}
                                  onClick={() => addFeedback(auth.id, CORRECT_FEEDBACK)}
                                  title="Confirm as correct"
                                >
                                  <img src={CheckMarkFilled} alt="" />
                                  <span style={{color: "#63B96C"}}>Confirm Finding</span>
                                </button>
                                <div className="vr"></div>
                                <button
                                  type="button"
                                  className="issue-action-button"
                                  disabled={submittingEntityIds.has(auth.id)}
                                  onClick={() => onIncorrectFeedbackClicked(auth)}
                                  title="Reject as incorrect"
                                >
                                  <img src={CancelMarkFilled} alt="" />
                                  <span className="themed-reject">Reject Finding</span>
                                </button>
                              </>}
                            </div>}
                            <hr/>
                          </>)}
                        </div>
                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>
                </Accordion>
                {/* Bulk Actions Components */}
                {!transactionDetails.facility.prohibitTraining && assessmentResult && (
                  <>
                    <BulkActionsBar
                      selectedCount={selectedEntityIds.size}
                      onConfirmAll={handleBulkConfirm}
                      onRejectAll={handleBulkReject}
                      onClearSelection={clearSelection}
                      onUndo={handleUndo}
                      canUndo={bulkActionHistory.length > 0 || 
                        Array.from(selectedEntityIds).some( id => {
                          const entity = assessmentResult?.detectedEntities.find(e => e.id === id);
                          return entity?.feedback !== undefined
                        })}
                      undoCount={bulkActionHistory.length > 0
                        ? bulkActionHistory[bulkActionHistory.length -1].affectedEntities.length
                        : Array.from(selectedEntityIds).filter(id => {
                          const entity = assessmentResult?.detectedEntities.find(e => e.id === id);
                          return entity?.feedback !== undefined;
                        }).length
                      }
                      disabled={selectedEntityIds.size === 0}
                    />
                    
                    <BulkFeedbackModal
                      isOpen={showBulkRejectModal}
                      onClose={() => setShowBulkRejectModal(false)}
                      onSubmit={handleBulkRejectSubmit}
                      selectedCount={selectedEntityIds.size}
                      feedbackTypes={(props.aiFeedback || []).filter(fb => fb.id !== CORRECT_FEEDBACK)}
                      actionType="reject"
                      isSubmitting={isBulkSubmitting}
                    />
                  </>
                )}
              </div>}
              {props.QAFeatureFlags?.finalQAAccordions && !props.transactionDetails.isInAIProcessing && <div className="ai-empty-results">
                {
                  props.transactionDetails.facility.qaExcluded ?
                    "This transaction is not eligible for AI Assessment."
                  :
                    "This transaction has not been submitted for the Assessment Process."
                }
              </div>}
              {props.QAFeatureFlags?.finalQAAccordions && props.transactionDetails.aiProcessingFailed && <div className="ai-failed-results">
                <img src={UrgentOutlineSmall} alt="" />
                <span>
                  An error occurred with the Assessment Process. Contact an administrator to restart it.
                </span>
              </div>}
              {/* See "AI Findings" above -- themed via .section-headers. */}
              <span className="section-headers">Reviewer Findings</span>
              <Accordion>
                <Card>
                  <Accordion.Toggle className="section-semi-headers" as={Card.Header} variant="link" eventKey="1">
                    Issues
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey="1">
                    <Card.Body>
                      <div className="issue-block">
                        {!transactionDetails.isReadOnly && <div className="d-flex flex-row" style={{height: "14px"}}>
                          <input
                              type="checkbox"
                              className="checkbox-eye-openunchecked"
                              id="show-all-issues"
                              checked={showAllIssues}
                              onChange={onShowAllIssues}
                          />
                          <label htmlFor="show-all-issues">{showAllIssues ? "Hide Completed" : "Show Completed"}</label>
                        </div>}
                        <hr/>
                        <div className="issue-info">
                          <div className="issue-col issue-underline">
                            Issue
                          </div>
                          <div className="page-col issue-underline">
                            Page
                          </div>
                          <div className="added-col issue-underline">
                            Added By
                          </div>
                          <div className="made-col issue-underline">
                            Issue Made By
                          </div>
                        </div>
                        {qaIssues.filter((row) =>
                            showAllIssues || (row.active && !row.resolved)
                        ).map((row) => (<>
                          <div className="issue-info">
                            <div className={`issue-col ${(!row.resolved && row.active) || row.disputed ? "themed-link" : "themed-muted"}`} style={{
                              textDecoration: row.active ? "" : "line-through",
                              cursor: row.canEdit ? "pointer" : "",
                            }}>
                              <span
                                title={row.canEdit ? "Edit" : ""}
                                onClick={() => {
                                  if (row.canEdit) {
                                    showIssueEditForm(row);
                                  }
                                }}
                                style={{fontWeight: "600", fontSize: "12px"}}
                              >
                                ({row.qaErrorTypeName}) {row.qaErrorName}
                              </span>
                            </div>
                            <div className="page-col">
                              <span
                                role="button"
                                className="themed-link"
                                onClick={() => {
                                  if (row.pageNumber) {
                                    handlePageClick(row.pageNumber, row.fileName);
                                  }
                                }}
                              >
                                {row.pageNumber}
                              </span>
                            </div>
                            <div className={`added-col${(row.resolved || !row.active) && !row.disputed ? " themed-muted" : ""}`} style={{
                              textDecoration: row.active ? "" : "line-through",
                            }}>
                              <span>{row.firstName} {row.lastName}</span>
                            </div>
                            <div className={`made-col${(row.resolved || !row.active) && !row.disputed ? " themed-muted" : ""}`} style={{
                              textDecoration: row.active ? "" : "line-through",
                            }}>
                              <span>{row.madeBy.displayName}</span>
                            </div>
                          </div>
                          <div className={`issue-details${(row.resolved || !row.active) && !row.disputed ? " themed-muted" : ""}`} style={{
                            textDecoration: row.active ? "" : "line-through",
                          }}>
                            {!row.active && <img
                              src={CancelOutlineLarge}
                              height={19}
                              width={19}
                              alt=""
                            />}
                            {row.active && row.resolved && !row.disputed && <img
                              src={CheckOutlineLarge}
                              height={19}
                              width={19}
                              alt=""
                            />}
                            <span>
                              {row.issueDetails}
                            </span>
                          </div>
                          {row.active && !row.resolved && !transactionDetails.isReadOnly && <div
                            className="issue-actions"
                          >
                            <button
                              type="button"
                              className="issue-action-button"
                              onClick={async () => await onIssueResolved(row.issueID)}
                            >
                              <img src={CheckMarkFilled} alt="" />
                              <span style={{color: "#63B96C"}}>Issue Resolved</span>
                            </button>
                            <div className="vr"></div>
                            <button
                              type="button"
                              className="issue-action-button"
                              disabled={!row.canRemove}
                              title={row.canRemove ? "" : "You cannot remove this issue."}
                              onClick={async () => await onIssueRemoved(row.issueID)}
                            >
                              <img src={CancelMarkFilled} alt="" />
                              <span className="themed-reject">Remove Issue</span>
                            </button>
                          </div>}
                          {row.canDispute && disputingIssueId != row.issueID && <div className="issue-actions">
                            <button
                              type="button"
                              className="issue-action-button"
                              onClick={() => setDisputeForm(row.issueID)}
                            >
                              <img
                                src={UrgentFilledSmall}
                                width={14}
                                height={14}
                                alt=""
                              />
                              <span className="themed-link">Dispute Issue</span>
                            </button>
                          </div>}
                          {row.disputed && <div
                            className="issue-dispute"
                          >
                            <div className="dispute-header">
                              <img
                                src={UrgentOutlineLarge}
                                width={19}
                                height={19}
                                alt=""
                              />
                              Issue Disputed
                            </div>
                            <p>{row.disputeReason}</p>
                          </div>}
                          {row.disputed && <div className="issue-actions">
                            <button
                              type="button"
                              className="issue-action-button edit-link-button"
                              disabled={!row.canEdit}
                              title={row.canEdit ? "" : "You cannot edit this issue."}
                              onClick={() => showIssueEditForm(row)}
                            >
                              <img src={EditFilledSmall} alt="" />
                              <span>Edit Issue</span>
                            </button>
                            <div className="vr"></div>
                            <button
                              type="button"
                              className="issue-action-button"
                              disabled={!row.canUphold}
                              title={row.canUphold ? "" : "You cannot uphold this issue."}
                              onClick={() => setDisputeForm(row.issueID)}
                            >
                              <img src={CheckMarkFilled} alt="" />
                              <span style={{color: "#63B96C"}}>Issue Upheld</span>
                            </button>
                            <div className="vr"></div>
                            <button
                              type="button"
                              className="issue-action-button"
                              disabled={!row.canRemove}
                              title={row.canRemove ? "" : "You cannot remove this issue."}
                              onClick={async () => await onIssueRemoved(row.issueID)}
                            >
                              <img src={CancelMarkFilled} alt="" />
                              <span className="themed-reject">Remove Issue</span>
                            </button>
                          </div>}
                          {disputingIssueId == row.issueID && <div className="issue-dispute">
                            <span className="dispute-header">
                              {row.disputed ? "Uphold" : "Dispute"} Issue
                            </span>
                            <label htmlFor={"dispute-" + row.issueID}>
                              Reason for {row.disputed ? "Upholding Issue" : "Dispute"}
                            </label>
                            <textarea className="form-control" id={"dispute-" + row.issueID}></textarea>
                            <div className="dispute-actions">
                              <button
                                type="button"
                                className="cancel-button"
                                onClick={() => cancelIssueEdit()}
                              >
                                Cancel
                              </button>
                              <button
                                type="button"
                                className="btn"
                                onClick={() => onSubmitDispute(row)}
                              >
                                <img src={ForwardOutlineLarge} alt="" />
                                Submit {row.disputed ? "Uphold" : "Dispute"}
                              </button>
                            </div>
                          </div>}
                          <hr/>
                        </>))}
                      </div>
                      <br/>
                      {!transactionDetails.isReadOnly && <div className="add-issue-container">
                        {!(transactionDetails.transactionStatus?.id >= 130 && transactionDetails.transactionStatus?.id <= 141 && transactionDetails.transactionDds?.id !== 140) ? (
                          <span className="d-inline-block" title="Issues may only be added when the transaction is in QA status.">
                            <a
                              href="#"
                              id="add-issue-link"
                              className="disabled-link"
                              style={{ pointerEvents: "none", opacity: 0.5 }}
                            >
                              <img src={AddNewIssue} className="add-new-issue-icon" alt="" />
                              Add Issue
                            </a>
                          </span>
                        ) : (
                          <a href="#" id="add-issue-link" onClick={() => showIssueAddForm()}>
                            <img src={AddNewIssue} className="add-new-issue-icon" alt="" />
                            Add Issue
                          </a>
                        )}
                        {props.currentFileType != DocTypes.RELEASE && props.currentFileType != DocTypes.QA && <div className="pd-issue-warning">
                          Select Release Document to add issues.
                        </div>}
                      </div>}
                      {showForm && <AddIssueForm
                        documentsList={documentsList}
                        close={cancelIssueEdit}
                        qaErrors={props.qaErrors ?? []}
                        userAttributes={props.userAttributes}
                        transactionId={props.transactionId}
                        editIssue={editIssue}
                      />}
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
              </Accordion>
              {props.QAFeatureFlags?.finalQAAccordions && !transactionDetails.facility.prohibitTraining && <div>
                <Accordion>
                  <Card>
                    <Accordion.Toggle className="section-semi-headers" as={Card.Header} variant="link" eventKey="0">
                      Sensitive Information
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey="0">
                      <Card.Body>
                        <div
                          className="d-inline-flex flex-row"
                          style={{height: "14px"}}
                          title="Show all found sensitive information below, even if it was authorized to be released."
                        >
                          <input
                              type="checkbox"
                              className="checkbox-eye-openunchecked"
                              id="show-authorized-review-entities"
                              checked={showAuthorizedEntities}
                              onChange={event => setShowAuthorizedEntities(event.target.checked)}
                          />
                          <label htmlFor="show-authorized-review-entities">{showAuthorizedEntities ? "Hide" : "Show"} Authorized</label>
                        </div>
                        <hr/>
                        <div className="issue-block">
                          <div className="issue-info">
                            <div className="text-col issue-underline">
                              Type
                            </div>
                            <div className="page-col issue-underline">
                              Page
                            </div>
                            <div className="added-col issue-underline">
                              Noted By
                            </div>
                            <div className="made-col issue-underline">
                              Submitted On
                            </div>
                          </div>
                          {reviewEntities.filter(ent =>
                            ent.type != RELEASE && ent.type != PATIENT
                          ).filter(shouldShowEntity).map(ent => {
                            const entType = props.entityTypes?.find(x => x.id == ent.type);
                            if (!entType) return null;
                            return <div className="issue-info">
                              <div className="text-col">
                                <span>
                                  {entType.name}
                                </span>
                              </div>
                              <div className="page-col">
                                <span
                                  role="button"
                                  className="themed-link"
                                  onClick={() => handlePageClick(ent.page + 1, qaDocDesc)}
                                >
                                  {ent.page + 1}
                                </span>
                              </div>
                              <div className="added-col">
                                <span>
                                  {ent.lastName}, {ent.firstName}
                                </span>
                              </div>
                              <div className="made-col">
                                <span>
                                  {ent.submitted.toLocaleDateString()}
                                </span>
                              </div>
                            </div>
                          })}
                        </div>
                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>
                </Accordion>
                { props.QAFeatureFlags?.finalQAShowCominglingNames === true &&
                <Accordion>
                  <Card>
                    <Accordion.Toggle className="section-semi-headers" as={Card.Header} variant="link" eventKey="1">
                      Comingling
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey="1">
                      <Card.Body>
                        <div className="issue-block">
                          <div className="issue-info">
                            <div className="text-col issue-underline">
                            </div>
                            <div className="page-col issue-underline">
                              Page
                            </div>
                            <div className="added-col issue-underline">
                              Noted By
                            </div>
                            <div className="made-col issue-underline">
                              Submitted On
                            </div>
                          </div>
                          {reviewEntities.filter(ent =>
                              ent.type == PATIENT
                          ).map(ent => <div className="issue-info">
                            <div className="text-col">
                            </div>
                            <div className="page-col">
                              <span
                                role="button"
                                className="themed-link"
                                onClick={() => handlePageClick(ent.page + 1, qaDocDesc)}
                              >
                                {ent.page + 1}
                              </span>
                            </div>
                            <div className="added-col">
                              <span>
                                {ent.lastName}, {ent.firstName}
                              </span>
                            </div>
                            <div className="made-col">
                              <span>
                                {ent.submitted.toLocaleDateString()}
                              </span>
                            </div>
                          </div>)}
                        </div>
                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>
                </Accordion>
                }
                <Accordion>
                  <Card>
                    <Accordion.Toggle className="section-semi-headers" as={Card.Header} variant="link" eventKey="2">
                      Patient Auth
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey="2">
                      <Card.Body>
                        <div className="issue-block">
                          <div className="issue-info">
                            <div className="text-col issue-underline">
                            </div>
                            <div className="page-col issue-underline">
                              Page
                            </div>
                            <div className="added-col issue-underline">
                              Noted By
                            </div>
                            <div className="made-col issue-underline">
                              Submitted On
                            </div>
                          </div>
                          {reviewEntities.filter(ent =>
                            ent.type == RELEASE
                          ).map(ent => <div className="issue-info">
                            <div className="text-col">
                            </div>
                            <div className="page-col">
                              <span
                                role="button"
                                className="themed-link"
                                onClick={() => handlePageClick(ent.page + 1, qaDocDesc)}
                              >
                                {ent.page + 1}
                              </span>
                            </div>
                            <div className="added-col">
                              <span>
                                {ent.lastName}, {ent.firstName}
                              </span>
                            </div>
                            <div className="made-col">
                              <span>
                                {ent.submitted.toLocaleDateString()}
                              </span>
                            </div>
                          </div>)}
                        </div>
                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>
                </Accordion>
              </div>}
              {showAddFeedback && entityType && props.aiFeedback && <>
                <AssessmentFeedbackPopUp
                  setShowAddFeedback={setShowAddFeedback}
                  addFeedback={addFeedback}
                  entityId={entityId}
                  entityType={entityType}
                  feedbackTypes={props.aiFeedback}
                />
              </>}
            </div>
          ) : null
        }
      </div>
      {props.hideFooter || transactionDetails.isReadOnly || transactionDetails.transactionStatus.id >= 130 ? <></> :
        <div className="panel-footer">
          <span
            className="float-left ml-3 mt-2"
            onClick={goToPreviousTransaction}
          >
            <Link to="/data">
              <i className="next-prev-link left-arrow"></i> Previous Request
            </Link>
          </span>
          <span
            className="float-left mt-2"
            onClick={createNewTransaction}
          >
          <img
            src={AddNewRequestor}
            alt={"Add Task"}
            className="add-new-icon"
            style={{paddingRight: '.5em'}}
          />
            <Link to="/data">
                  New Request
            </Link>
          </span>
          <span className="float-right mr-1 mt-2" onClick={goToNextTransaction}>
            <Link to="/data">
              Next Request <i className="next-prev-link right-arrow"></i>
            </Link>
          </span>
        </div>
      }
    </div>
  );
}

function mapStateToProps(state: RootState, props: IpropType): ReduxStateProps {
  const formState = state.form as FormStateMap;

  return {
    globalUserID: state.loginState.userID,
    userAttributes: state.loginState.userAttributes,
    requestorBillingDetails: props.requestorBillingDetails ?? state.dataEntryState.requestorBillingDetails,
    transactionNoteTypes: props.transactionNoteTypes || state.dataEntryState.transactionNoteTypes,
    rejectLetterData: props.rejectLetterData || state.dataEntryState.rejectLetterData,
    rejectLetterDataState: props.rejectLetterData || state.dataEntryState.rejectLetterDataState,
    organizationId: props.transactionDetails?.facility?.id ?? state.dataEntryState.transactionDetails?.facility?.id,
    facilityId: props.facilityId || state.landingPageState.selectedFacilityDetails?.facility.id,
    nextTransactionId: state.dataEntryState.nextTransactionId,
    previousTransactionId: state.dataEntryState.previousTransactionId,
    dataEntryFormState: props.dataEntryFormState || (state.form && formState[FormConstants.DATA_ENTRY_FIELDS_FORM]),
    userGroups: props.userGroups || state.dataEntryState.userGroups,
    rejectCompleted: state.dataEntryState.rejectCompleted,
    certificationRequired: state.dataEntryState.leftPaneTransactionDetails.certificationRequired,
    intiaTxlSagaCallCount: props.intiaTxlSagaCallCount || state.dataEntryState.intiaTxlSagaCallCount,
    requestContext: state.landingPageState.requestContext,
    QAFeatureFlags: state.loginState.QAFeatureFlags,
    selectedHoldReasons: generatePickerOptionsNoDefault(props.transactionDetails?.transactionWaitHold, "waitHoldReasonName", "waitHoldReasonID"),
    trackingLink: state.landingPageState.trackingLink,
    assessmentResult: state.dataEntryState.assessmentResult,
    aiFeedback: state.dataEntryState.aiFeedback,
    entityTypes: state.dataEntryState.getSensitivityTypes,
    submitAIFeedbackStatus: state.dataEntryState.submitAIFeedbackStatus,
  };
}

export function mapDispatchToProps(dispatch: (action: {type: string}) => void, props: IpropType) {
  return {
    patchPatientNotesData: (patientid: any, note: any, globalUserID: any, transactionId: any) =>
      dispatch(patchPatientNoteActionCreators(patientid, note, globalUserID, transactionId)),
    patchRequestorNotesData: (requestorid: any, note: any, globalUserID: any, contactId: any) =>
      dispatch(
        patchRequestorNoteActionCreators(requestorid, note, globalUserID, contactId)
      ),
    updateTransactionNotes: (data: any) => props.updateTransactionNotes ? props.updateTransactionNotes(data) : dispatch(updateTransactionNotes(data)),
    rejectionContactOverride: (data: any) =>
      dispatch(rejectionContactOverrideActionCreator(data)),
    getRejectionLetter: (transactionId: string) =>
      dispatch(getRejectionLetterActionCreator(transactionId)),
    getPreviousTransaction: (transactionId: string) =>
      dispatch(getPreviousTransactionActionCreator(transactionId)),
    setPreviousTransaction: (previousTransactionId: string) =>
      dispatch(setPreviousTransactionActionCreator(previousTransactionId)),
    getNextTransactionId: (facilityId: number, context: number) =>
      dispatch(nextTransactionIdActionCreator(facilityId, context)),
    setNextTransactionID: (transactionId: string) =>
      dispatch(setNextTransactionIdActionCreator(transactionId)),
    setNextTransactionIDNull: () =>
      dispatch(setNextTransactionNullActionCreator()),
    updateUserTasks: (data) => props.addNewTask ? props.addNewTask(data) : dispatch(updateUserTasksActionCreator(data)),
    updateUserTaskComments: (data) => props.updateUserTaskComments ? props.updateUserTaskComments(data) : dispatch(updateUserTaskCommentsActionCreator(data)),
    createUserTaskComment: (data) => props.createUserTaskComment ? props.createUserTaskComment(data) : dispatch(createUserTaskCommentActionCreator(data)),
    addNewTask: (data) => props.addNewTask ? props.addNewTask(data) : dispatch(addNewTaskActionCreator(data)),
    updateTask: (data) => props.updateTask ? props.updateTask(data) : dispatch(updateTaskActionCreator(data)),
    deleteTransactionTask: (transactionId: string, usertaskId: string) => props.deleteTransactionTask ? props.deleteTransactionTask(transactionId, usertaskId) : dispatch(deleteTransactionTaskActionCreator(transactionId, usertaskId)),
    postRejectionAction: (rejection: Rejection) =>
      dispatch(postRejectionDetailsActionCreator(rejection)),
    resetDataEntryState: () => dispatch(resetDataEntryState()),
    clearTransactionId: () => dispatch(clearTransactionId()),
    createTransaction: (data: any) => dispatch(createTransaction(data)),
    getTransactionAttributes: (transactionId: string) => dispatch(showReadOnlyTransactionRequest(transactionId)),
    sendOutboundTemplateFields: (templateId: any, transactionId: any, action: any, templateFields: any, context: any, contact: any) => dispatch(sendOutboundTemplateFieldsActionCreator(templateId, transactionId, action, templateFields, context, contact)),
    setEscalation: (data) => props.setEscalation && props.setEscalation(data),
    fetchQAIssues: (transactionId: string) => dispatch(getQAIssuesActionCreator(transactionId)),
    getQAPDIssues: (transactionId: string) => dispatch(getQAPDIssuesActionCreator(transactionId)),
    resolveQAIssue: (transactionId: string, issueId: string) => dispatch(resolveQATransactionIssueActionCreator(transactionId, issueId)),
    removeQAIssue: (transactionId: string, issueId: string) => dispatch(removeQATransactionIssueActionCreator(transactionId, issueId)),
    disputeIssue: (id: string, reason: string, transactionId: string) => dispatch(disputeIssueActionCreator(id, reason, transactionId)),
    upholdIssue: (id: string, reason: string, transactionId: string) => dispatch(upholdIssueActionCreator(id, reason, transactionId)),
    addFeedback: (entityId: string, feedbackType: string) => dispatch(submitAIFeedbackActionCreator(entityId, feedbackType)),
    deleteFeedback: (entityId: string) => dispatch(deleteAIFeedbackActionCreator(entityId)),
    submitAIFeedbackBulk: (entityIds: string[], feedbackType: string) => dispatch(submitAIFeedbackBulkActionCreator(entityIds, feedbackType)),
    undoAIFeedbackBulk: (entityIds: string[]) => dispatch(undoAIFeedbackBulkActionCreator(entityIds)),
    getAssessmentResults:(transactionId: string) => dispatch(getAssessmentResultsActionCreator(transactionId)),
    readBarCodeDDSRequest: (documentId: string) => dispatch(readBarCodeDDSRequest(documentId)),
    getQAFeatureFlagsRequest: () => dispatch(getQAFeatureFlagsRequest()),
  };
}

const DataEntryDetailsReduxForm = reduxForm({
  form: FormConstants.DATA_ENTRY_FIELDS_FORM,
  validate: localValidations,
  onSubmit: submitValidations,
  enableReinitialize: true,
  touchOnChange: true,
})(DataEntryDetailsLeftPane);

export default connect(
  mapStateToProps as any,
  mapDispatchToProps
)(DataEntryDetailsReduxForm);